import React from "react";

const EmptyStateDashboardSinglePage = ({ mobile }: { mobile: boolean }) =>
  mobile ? (
    <svg
      width="296"
      height="160"
      viewBox="0 0 296 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="296" height="159.385" fill="white" />
      <path
        d="M259.865 18.5H185.701C184.876 18.5 184.207 19.1692 184.207 19.9947V73.0825C184.207 73.908 184.876 74.5772 185.701 74.5772H259.865C260.69 74.5772 261.359 73.908 261.359 73.0825V19.9947C261.359 19.1692 260.69 18.5 259.865 18.5Z"
        fill="#E0E0E0"
      />
      <path
        d="M257.357 21.3814H189.214C188.389 21.3814 187.719 22.0506 187.719 22.8761V70.2009C187.719 71.0264 188.389 71.6956 189.214 71.6956H257.357C258.183 71.6956 258.852 71.0264 258.852 70.2009V22.8761C258.852 22.0506 258.183 21.3814 257.357 21.3814Z"
        fill="#EDEFF1"
      />
      <path
        d="M249.991 36.1709L248.58 32.7579C248.53 32.6417 248.438 32.5503 248.322 32.5005L244.909 31.0805C244.793 31.0307 244.66 31.0307 244.544 31.0805L241.131 32.5005C241.015 32.5503 240.923 32.6417 240.873 32.7579L239.462 36.1709C239.412 36.2872 239.412 36.42 239.462 36.5363L240.873 39.9492C240.923 40.0655 241.015 40.1568 241.131 40.2067L244.544 41.6184C244.66 41.6682 244.793 41.6682 244.909 41.6184L248.322 40.2067C248.438 40.1568 248.53 40.0655 248.58 39.9492L249.991 36.5363C250.041 36.42 250.041 36.2872 249.991 36.1709ZM249.476 36.5363L248.214 39.5922C248.164 39.7084 248.073 39.7998 247.957 39.8496L244.909 41.1118C244.793 41.1616 244.66 41.1616 244.544 41.1118L241.496 39.8496C241.38 39.7998 241.289 39.7084 241.239 39.5922L239.977 36.5363C239.927 36.42 239.927 36.2872 239.977 36.1709L241.239 33.1233C241.289 33.0071 241.38 32.9157 241.496 32.8659L244.544 31.6037C244.66 31.5539 244.793 31.5539 244.909 31.6037L247.957 32.8659C248.073 32.9157 248.164 33.0071 248.214 33.1233L249.476 36.1709C249.526 36.2872 249.526 36.42 249.476 36.5363Z"
        fill="#E0E0E0"
      />
      <path
        d="M248.115 36.1709L247.251 34.0783C247.201 33.962 247.11 33.8707 246.994 33.8209L244.901 32.9573C244.785 32.9074 244.652 32.9074 244.536 32.9573L242.443 33.8209C242.327 33.8707 242.235 33.962 242.186 34.0783L241.322 36.1709C241.272 36.2872 241.272 36.42 241.322 36.5363L242.186 38.6289C242.235 38.7452 242.327 38.8365 242.443 38.8863L244.536 39.75C244.652 39.7998 244.785 39.7998 244.901 39.75L246.994 38.8863C247.11 38.8365 247.201 38.7452 247.251 38.6289L248.115 36.5363C248.165 36.42 248.165 36.2872 248.115 36.1709ZM247.6 36.5363L246.886 38.2635C246.836 38.3798 246.745 38.4711 246.628 38.521L244.901 39.2351C244.785 39.2849 244.652 39.2849 244.536 39.2351L242.808 38.521C242.692 38.4711 242.601 38.3798 242.551 38.2635L241.837 36.5363C241.787 36.42 241.787 36.2872 241.837 36.1709L242.551 34.4437C242.601 34.3274 242.692 34.2361 242.808 34.1863L244.536 33.4721C244.652 33.4223 244.785 33.4223 244.901 33.4721L246.628 34.1863C246.745 34.2361 246.836 34.3274 246.886 34.4437L247.6 36.1709C247.65 36.2872 247.65 36.42 247.6 36.5363Z"
        fill="#E0E0E0"
      />
      <path
        d="M246.429 36.1709L246.055 35.2741C246.005 35.1578 245.914 35.0665 245.798 35.0167L244.909 34.643C244.793 34.5932 244.66 34.5932 244.544 34.643L243.655 35.0167C243.539 35.0665 243.448 35.1578 243.398 35.2741L243.024 36.1709C242.974 36.2872 242.974 36.4201 243.024 36.5363L243.398 37.4331C243.448 37.5494 243.539 37.6407 243.655 37.6906L244.544 38.0643C244.66 38.1141 244.793 38.1141 244.909 38.0643L245.798 37.6906C245.914 37.6407 246.005 37.5494 246.055 37.4331L246.429 36.5363C246.479 36.4201 246.479 36.2872 246.429 36.1709ZM245.914 36.5363L245.698 37.0678C245.648 37.184 245.557 37.2754 245.441 37.3252L244.918 37.5411C244.801 37.5909 244.668 37.5909 244.552 37.5411L244.029 37.3252C243.913 37.2754 243.821 37.184 243.772 37.0678L243.556 36.5363C243.506 36.4201 243.506 36.2872 243.556 36.1709L243.772 35.6395C243.821 35.5232 243.913 35.4319 244.029 35.382L244.552 35.1661C244.668 35.1163 244.801 35.1163 244.918 35.1661L245.441 35.382C245.557 35.4319 245.648 35.5232 245.698 35.6395L245.914 36.1709C245.964 36.2872 245.964 36.4201 245.914 36.5363Z"
        fill="#E0E0E0"
      />
      <path
        d="M249.319 31.9442C249.319 31.9442 250.398 29.6523 252.889 29.8931"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M252.499 28.988L253.371 29.9679L252.407 30.8232"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M256.634 28.2904L254.824 30.0924"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M255.048 28.7638C255.222 28.7638 255.364 28.6225 255.364 28.4482C255.364 28.274 255.222 28.1327 255.048 28.1327C254.874 28.1327 254.733 28.274 254.733 28.4482C254.733 28.6225 254.874 28.7638 255.048 28.7638Z"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M256.468 30.217C256.642 30.217 256.784 30.0757 256.784 29.9015C256.784 29.7272 256.642 29.5859 256.468 29.5859C256.294 29.5859 256.152 29.7272 256.152 29.9015C256.152 30.0757 256.294 30.217 256.468 30.217Z"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M194.221 60.5682C194.221 60.5682 195.807 57.612 197.186 57.612C198.564 57.612 199.395 61.0001 201.712 61.0001C204.028 61.0001 205.656 57.612 205.656 57.612"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.277 58.2182C197.616 58.2182 197.891 57.9431 197.891 57.6037C197.891 57.2643 197.616 56.9892 197.277 56.9892C196.937 56.9892 196.662 57.2643 196.662 57.6037C196.662 57.9431 196.937 58.2182 197.277 58.2182Z"
        fill="#E0E0E0"
      />
      <path
        d="M201.645 61.6061C201.985 61.6061 202.26 61.331 202.26 60.9916C202.26 60.6522 201.985 60.3771 201.645 60.3771C201.306 60.3771 201.031 60.6522 201.031 60.9916C201.031 61.331 201.306 61.6061 201.645 61.6061Z"
        fill="#E0E0E0"
      />
      <path
        d="M205.655 58.1101C205.995 58.1101 206.27 57.835 206.27 57.4956C206.27 57.1563 205.995 56.8811 205.655 56.8811C205.316 56.8811 205.041 57.1563 205.041 57.4956C205.041 57.835 205.316 58.1101 205.655 58.1101Z"
        fill="#E0E0E0"
      />
      <path
        d="M194.221 61.4151C194.561 61.4151 194.836 61.14 194.836 60.8006C194.836 60.4612 194.561 60.1861 194.221 60.1861C193.882 60.1861 193.607 60.4612 193.607 60.8006C193.607 61.14 193.882 61.4151 194.221 61.4151Z"
        fill="#E0E0E0"
      />
      <path
        d="M206.27 53.518L206.835 54.4896L208.861 51.9319"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M243.29 56.765H241.886C241.561 56.765 241.297 57.029 241.297 57.3546V60.942C241.297 61.2676 241.561 61.5316 241.886 61.5316H243.29C243.615 61.5316 243.879 61.2676 243.879 60.942V57.3546C243.879 57.029 243.615 56.765 243.29 56.765Z"
        fill="#E0E0E0"
      />
      <path
        d="M246.893 54.1907H245.49C245.164 54.1907 244.9 54.4547 244.9 54.7803V60.9419C244.9 61.2675 245.164 61.5315 245.49 61.5315H246.893C247.219 61.5315 247.483 61.2675 247.483 60.9419V54.7803C247.483 54.4547 247.219 54.1907 246.893 54.1907Z"
        fill="#E0E0E0"
      />
      <path
        d="M250.497 51.5916H249.094C248.768 51.5916 248.504 51.8556 248.504 52.1812V60.942C248.504 61.2676 248.768 61.5316 249.094 61.5316H250.497C250.823 61.5316 251.087 61.2676 251.087 60.942V52.1812C251.087 51.8556 250.823 51.5916 250.497 51.5916Z"
        fill="#E0E0E0"
      />
      <path
        d="M254.309 55.8185H252.905C252.58 55.8185 252.316 56.0825 252.316 56.4081V60.9421C252.316 61.2677 252.58 61.5317 252.905 61.5317H254.309C254.634 61.5317 254.898 61.2677 254.898 60.9421V56.4081C254.898 56.0825 254.634 55.8185 254.309 55.8185Z"
        fill="#E0E0E0"
      />
      <path
        d="M204.095 35.8802H195.625C195.492 35.8802 195.393 35.7723 195.393 35.6477V28.2405C195.393 28.1076 195.501 28.008 195.625 28.008C195.75 28.008 195.858 28.1159 195.858 28.2405V35.4069H204.095C204.228 35.4069 204.328 35.5149 204.328 35.6394C204.328 35.764 204.22 35.8719 204.095 35.8719V35.8802Z"
        fill="#E0E0E0"
      />
      <path
        d="M195.625 35.8804C195.567 35.8804 195.5 35.8554 195.459 35.8139C195.367 35.7226 195.367 35.5731 195.459 35.4818L199.254 31.7532C199.337 31.6702 199.461 31.6619 199.553 31.7283L201.413 33.057L203.622 30.5409C203.705 30.4412 203.854 30.4329 203.954 30.5159C204.053 30.599 204.062 30.7485 203.979 30.8481L201.629 33.5303C201.546 33.6217 201.413 33.6383 201.313 33.5635L199.445 32.2183L195.791 35.8056C195.741 35.8471 195.683 35.872 195.625 35.872V35.8804Z"
        fill="#E0E0E0"
      />
      <path
        d="M204.228 31.8196C204.112 31.8196 204.004 31.7283 203.995 31.6037L203.904 30.6072L202.908 30.6986C202.766 30.7069 202.667 30.6155 202.65 30.491C202.642 30.3581 202.733 30.2502 202.858 30.2335L204.087 30.1173C204.211 30.1007 204.328 30.2003 204.344 30.3249L204.46 31.5539C204.469 31.6868 204.377 31.7947 204.253 31.8113H204.228V31.8196Z"
        fill="#E0E0E0"
      />
      <path
        d="M222.231 55.7269L222.123 57.0307L220.845 56.9227"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M223.534 58.351H232.403"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M223.534 59.8956H230.551"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M223.534 61.5231H227.288"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M222.879 40.2232C223.245 40.2232 223.535 39.9326 223.535 39.5672C223.535 39.2018 223.245 38.9112 222.879 38.9112C222.514 38.9112 222.223 39.2018 222.223 39.5672C222.223 39.9326 222.514 40.2232 222.879 40.2232Z"
        fill="#E0E0E0"
      />
      <path
        d="M224.058 41.2613C223.875 40.7797 223.419 40.4392 222.87 40.4392C222.322 40.4392 221.866 40.7797 221.683 41.2613C221.6 41.4772 221.774 41.7014 222.007 41.7014H223.734C223.958 41.7014 224.133 41.4772 224.058 41.2613Z"
        fill="#E0E0E0"
      />
      <path
        d="M226.623 40.2232C226.989 40.2232 227.279 39.9326 227.279 39.5672C227.279 39.2018 226.989 38.9112 226.623 38.9112C226.258 38.9112 225.967 39.2018 225.967 39.5672C225.967 39.9326 226.258 40.2232 226.623 40.2232Z"
        fill="#E0E0E0"
      />
      <path
        d="M227.811 41.2613C227.628 40.7797 227.172 40.4392 226.624 40.4392C226.076 40.4392 225.619 40.7797 225.436 41.2613C225.353 41.4772 225.528 41.7014 225.76 41.7014H227.487C227.711 41.7014 227.886 41.4772 227.811 41.2613Z"
        fill="#E0E0E0"
      />
      <path
        d="M215.372 40.2232C215.737 40.2232 216.028 39.9326 216.028 39.5672C216.028 39.2018 215.737 38.9112 215.372 38.9112C215.007 38.9112 214.716 39.2018 214.716 39.5672C214.716 39.9326 215.007 40.2232 215.372 40.2232Z"
        fill="#E0E0E0"
      />
      <path
        d="M216.551 41.2613C216.368 40.7797 215.911 40.4392 215.363 40.4392C214.815 40.4392 214.358 40.7797 214.176 41.2613C214.093 41.4772 214.267 41.7014 214.5 41.7014H216.227C216.451 41.7014 216.625 41.4772 216.551 41.2613Z"
        fill="#E0E0E0"
      />
      <path
        d="M219.125 40.2232C219.49 40.2232 219.781 39.9326 219.781 39.5672C219.781 39.2018 219.49 38.9112 219.125 38.9112C218.76 38.9112 218.469 39.2018 218.469 39.5672C218.469 39.9326 218.76 40.2232 219.125 40.2232Z"
        fill="#E0E0E0"
      />
      <path
        d="M220.304 41.2613C220.121 40.7797 219.665 40.4392 219.116 40.4392C218.568 40.4392 218.112 40.7797 217.929 41.2613C217.846 41.4772 218.02 41.7014 218.253 41.7014H219.98C220.204 41.7014 220.379 41.4772 220.304 41.2613Z"
        fill="#E0E0E0"
      />
      <path
        d="M222.879 44.7905C223.245 44.7905 223.535 44.4999 223.535 44.1345C223.535 43.7691 223.245 43.4785 222.879 43.4785C222.514 43.4785 222.223 43.7691 222.223 44.1345C222.223 44.4999 222.514 44.7905 222.879 44.7905Z"
        fill="#E0E0E0"
      />
      <path
        d="M224.058 45.8369C223.875 45.3553 223.419 45.0148 222.87 45.0148C222.322 45.0148 221.866 45.3553 221.683 45.8369C221.6 46.0528 221.774 46.277 222.007 46.277H223.734C223.958 46.277 224.133 46.0528 224.058 45.8369Z"
        fill="#E0E0E0"
      />
      <path
        d="M226.623 44.7905C226.989 44.7905 227.279 44.4999 227.279 44.1345C227.279 43.7691 226.989 43.4785 226.623 43.4785C226.258 43.4785 225.967 43.7691 225.967 44.1345C225.967 44.4999 226.258 44.7905 226.623 44.7905Z"
        fill="#E0E0E0"
      />
      <path
        d="M227.811 45.8369C227.628 45.3553 227.172 45.0148 226.624 45.0148C226.076 45.0148 225.619 45.3553 225.436 45.8369C225.353 46.0528 225.528 46.277 225.76 46.277H227.487C227.711 46.277 227.886 46.0528 227.811 45.8369Z"
        fill="#E0E0E0"
      />
      <path
        d="M215.372 44.7905C215.737 44.7905 216.028 44.4999 216.028 44.1345C216.028 43.7691 215.737 43.4785 215.372 43.4785C215.007 43.4785 214.716 43.7691 214.716 44.1345C214.716 44.4999 215.007 44.7905 215.372 44.7905Z"
        fill="#E0E0E0"
      />
      <path
        d="M216.551 45.8369C216.368 45.3553 215.911 45.0148 215.363 45.0148C214.815 45.0148 214.358 45.3553 214.176 45.8369C214.093 46.0528 214.267 46.277 214.5 46.277H216.227C216.451 46.277 216.625 46.0528 216.551 45.8369Z"
        fill="#E0E0E0"
      />
      <path
        d="M219.125 44.7905C219.49 44.7905 219.781 44.4999 219.781 44.1345C219.781 43.7691 219.49 43.4785 219.125 43.4785C218.76 43.4785 218.469 43.7691 218.469 44.1345C218.469 44.4999 218.76 44.7905 219.125 44.7905Z"
        fill="#E0E0E0"
      />
      <path
        d="M220.304 45.8369C220.121 45.3553 219.665 45.0148 219.116 45.0148C218.568 45.0148 218.112 45.3553 217.929 45.8369C217.846 46.0528 218.02 46.277 218.253 46.277H219.98C220.204 46.277 220.379 46.0528 220.304 45.8369Z"
        fill="#E0E0E0"
      />
      <path
        d="M219.781 48.8678C219.781 48.8678 217.606 53.7589 221.899 56.6985"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M198.863 70.342H191.165C191.028 70.342 190.916 70.4535 190.916 70.5911V71.5627C190.916 71.7003 191.028 71.8118 191.165 71.8118H198.863C199.001 71.8118 199.112 71.7003 199.112 71.5627V70.5911C199.112 70.4535 199.001 70.342 198.863 70.342Z"
        fill="#E0E0E0"
      />
      <path
        d="M23.8221 140.395H20.6333C19.5704 140.395 18.6487 139.673 18.3995 138.635L5.76079 86.2528C5.60302 85.6217 5.71927 84.9491 6.09295 84.4093L8.94124 79.5099C8.76686 79.8421 8.71703 80.2407 8.81668 80.6393L23.8221 140.395Z"
        fill="#6FAAE3"
      />
      <path
        d="M69.5772 140.395H23.8219L8.81653 80.6392C8.71689 80.2406 8.76671 79.842 8.9411 79.5098C8.9411 79.4932 8.9494 79.4683 8.96601 79.4517L9.05735 79.3022C9.34799 78.8621 9.84624 78.5715 10.4275 78.5715H55.7095C56.4651 78.5715 57.1295 79.0863 57.3204 79.8254L71.811 137.538C72.1764 138.992 71.0802 140.395 69.5772 140.395Z"
        fill="#A4C9EB"
      />
      <path
        d="M60.6013 62.7771C60.6013 62.7771 63.6987 64.8033 63.0842 68.2412C62.4697 71.6791 62.7188 70.8819 63.5742 72.8499C64.4295 74.818 65.1685 76.2546 63.8814 78.9119C62.5943 81.5692 67.1449 81.4778 65.5422 86.1032C63.9395 90.7285 66.3394 89.4912 67.0203 92.6219C67.7013 95.7525 65.6668 98.9495 62.6607 97.9614C59.6547 96.9732 56.9558 99.6222 53.6093 99.0077C50.2628 98.3932 45.0063 97.5628 46.4014 91.4095C47.7965 85.2562 49.3327 84.2182 48.7847 80.1907C48.2366 76.1632 43.5365 72.6672 46.7419 67.3859C49.9472 62.1045 49.64 57.3214 49.64 57.3214C49.64 57.3214 58.2845 56.3913 60.6096 62.7771H60.6013Z"
        fill="#D34F16"
      />
      <path
        d="M60.3768 65.1938C60.3768 65.1938 60.2439 65.8581 61.0909 67.1286C61.9379 68.3991 61.9546 70.2675 61.4231 71.4965C60.2024 74.2867 62.5524 74.9842 62.3614 77.0104C62.1705 79.0366 60.0363 79.9417 61.6722 82.0925C62.8929 83.6952 62.6023 84.3097 61.7553 86.477C60.9082 88.6444 60.7671 89.4499 63.3247 92.5805C65.2263 94.9056 48.8674 95.2129 50.7192 88.0548C52.571 80.8967 51.2756 74.1206 52.3966 72.219C53.5176 70.3174 53.31 61.3656 60.3768 65.2021V65.1938Z"
        fill="#A53007"
      />
      <path
        d="M67.5271 133.403C67.66 137.198 70.8404 140.163 74.6437 140.03C75.8727 139.988 77.0103 139.623 77.9902 139.025C78.8538 138.493 79.7091 137.945 80.606 137.48L101.117 128.113L99.7385 122.649L74.4527 126.278L72.6922 126.494C69.628 127.275 67.4108 130.106 67.5354 133.403H67.5271Z"
        fill="#E0E0E0"
      />
      <path
        d="M55.8517 100.818L67.9424 135.33L80.9133 130.737L68.7147 96.6079C68.0503 93.8592 65.7169 91.7251 62.744 91.4427C59.0155 91.094 55.7105 93.8426 55.3618 97.5711C55.2538 98.7171 55.4365 99.8215 55.8517 100.818Z"
        fill="#E0E0E0"
      />
      <path
        d="M69.8192 139.49H32.4593L21.2239 101.374C19.7043 96.2592 22.4612 90.8366 27.4437 89.1675C30.9148 88.005 35.947 87.1746 43.2297 87.1746C53.8505 87.1746 60.1782 88.8603 63.9316 90.7453C67.328 92.4559 69.3043 96.1429 68.8642 99.9711L69.8192 139.49Z"
        fill="#E6A898"
      />
      <path
        d="M21.2239 101.374L24.0639 111.015L32.4593 139.49H69.8192L68.8642 99.9711C69.3043 96.1429 67.328 92.4559 63.9316 90.7453C60.1782 88.8603 53.8505 87.1746 43.2297 87.1746C38.5047 87.1746 34.7346 87.5233 31.7119 88.088C30.076 88.3953 28.6644 88.7606 27.4437 89.1675C22.4612 90.8366 19.7043 96.2592 21.2239 101.374Z"
        fill="#EDEFF1"
      />
      <path
        d="M21.2242 100.511L21.3239 100.793L33.4228 135.338L46.3938 130.746L34.1951 96.6162C33.5391 93.8676 31.1891 91.7251 28.2245 91.4511C24.496 91.1023 21.1827 93.851 20.8422 97.5795C20.7426 98.6009 20.892 99.5974 21.2242 100.511Z"
        fill="#E0E0E0"
      />
      <path
        d="M32.9166 133.486C33.0495 137.281 36.2299 140.246 40.0332 140.113C41.2622 140.071 42.3998 139.706 43.3797 139.108C44.2433 138.577 45.0987 138.029 45.9955 137.564L66.5065 128.197L65.128 122.733L39.8422 126.361L38.0817 126.577C35.0175 127.358 32.8004 130.19 32.9249 133.486H32.9166Z"
        fill="#E0E0E0"
      />
      <path
        d="M62.2713 126.843C62.5204 127.557 63.0186 128.113 63.6331 128.446C63.6913 128.487 63.7577 128.52 63.8241 128.545C63.957 128.603 64.1065 128.637 64.2642 128.637L64.5715 128.587L72.3856 127.316C72.3856 127.316 72.4354 127.325 72.4603 127.333L77.9078 128.603C77.9078 128.603 77.9742 128.62 78.0157 128.628C78.0988 128.645 78.1901 128.645 78.2815 128.62C78.3396 128.603 78.3894 128.587 78.4392 128.562C78.705 128.421 78.8461 128.113 78.7797 127.806C78.7299 127.615 78.6053 127.466 78.4392 127.383L78.0988 127.167H79.5354C79.5852 127.159 79.6433 127.142 79.6931 127.134C80.4073 126.959 80.8474 126.237 80.673 125.531C80.6398 125.381 80.5734 125.24 80.4903 125.116L77.6171 121.022C77.4843 120.814 77.2933 120.648 77.0691 120.548C76.8947 120.465 76.712 120.424 76.5127 120.424H68.4495C68.3332 120.424 68.217 120.441 68.1007 120.465C67.9346 120.507 67.7768 120.573 67.6357 120.665C67.6357 120.665 67.6274 120.665 67.6191 120.681L64.6213 122.641L63.6414 123.281L63.2511 123.53L63.2262 123.555C62.263 124.31 61.8395 125.622 62.2713 126.843Z"
        fill="#D28070"
      />
      <path
        d="M62.2713 126.851C62.5204 127.565 63.0186 128.122 63.6331 128.454C63.6913 128.495 63.7577 128.529 63.8241 128.554C63.957 128.612 64.1065 128.645 64.2642 128.645C64.5715 128.645 64.8538 128.52 65.0614 128.313L69.2134 124.103C69.5207 123.737 70.0605 123.712 70.4009 124.011C70.459 124.053 70.5089 124.103 70.5504 124.169L71.1151 124.999L72.1946 126.577C72.4188 126.918 72.7842 127.142 73.1911 127.175H79.5354C79.5852 127.167 79.6433 127.15 79.6931 127.142C80.4073 126.968 80.8474 126.245 80.673 125.539C80.6398 125.39 80.5734 125.249 80.4903 125.124L77.6171 121.03C77.4843 120.823 77.2933 120.656 77.0691 120.557C76.8947 120.474 76.712 120.432 76.5127 120.432H68.4495C68.3332 120.432 68.217 120.449 68.1007 120.474C67.9346 120.515 67.7768 120.582 67.6357 120.673C67.6357 120.681 67.6274 120.681 67.6191 120.69L64.6213 122.649L63.6414 123.289L63.2511 123.538L63.2262 123.563C62.263 124.319 61.8395 125.631 62.2713 126.851Z"
        fill="#E4A696"
      />
      <path
        d="M102.064 126.145L105.12 125.647L104.555 124.817C104.248 124.36 103.583 124.327 103.226 124.75L102.064 126.145Z"
        fill="#E6A898"
      />
      <path
        d="M96.2844 127.491C96.6 128.396 97.3225 129.052 98.1695 129.326C98.1778 129.326 98.1861 129.326 98.1944 129.334L98.5348 129.409C98.5348 129.409 98.5847 129.417 98.6096 129.426L104.057 130.696C104.057 130.696 104.123 130.713 104.165 130.721C104.248 130.738 104.339 130.738 104.431 130.713C104.489 130.696 104.539 130.679 104.588 130.655C104.854 130.513 104.995 130.206 104.929 129.899C104.879 129.708 104.755 129.558 104.588 129.475L101.898 127.815C101.848 127.781 101.798 127.748 101.757 127.69C101.45 127.408 101.416 126.909 101.707 126.569L101.989 126.229L102.072 126.137L103.227 124.742C103.534 124.377 104.074 124.352 104.414 124.651C104.472 124.692 104.522 124.742 104.564 124.809L105.128 125.639L106.208 127.217C106.432 127.557 106.797 127.781 107.204 127.815H113.549C113.598 127.806 113.657 127.79 113.706 127.781C114.42 127.607 114.861 126.885 114.686 126.179C114.653 126.029 114.587 125.888 114.504 125.764L111.63 121.67C111.497 121.462 111.306 121.296 111.082 121.196C110.908 121.113 110.725 121.072 110.526 121.072H102.463C102.346 121.072 102.23 121.088 102.114 121.113C101.948 121.155 101.79 121.221 101.649 121.313C101.649 121.321 101.641 121.321 101.632 121.329L98.6345 123.289L97.6546 123.928L97.2643 124.177L97.2394 124.202C96.2761 124.958 95.8526 126.27 96.2844 127.491Z"
        fill="#D58270"
      />
      <path
        d="M41.9757 73.1987C42.0671 73.2901 42.1252 73.4146 42.1252 73.5558C42.1252 73.8215 41.9093 74.0374 41.6436 74.0374C41.3779 74.0374 41.1536 73.8215 41.1536 73.5558C41.1536 73.2901 41.3696 73.0658 41.6436 73.0658C41.7017 73.0658 41.7515 73.0742 41.8014 73.0908C42.3909 71.9863 42.5404 71.1476 42.2249 70.5829C41.8595 69.9103 40.9543 69.8771 40.946 69.8771V69.6695C40.9959 69.6695 41.984 69.711 42.4076 70.4833C42.7563 71.1144 42.6069 72.0195 41.9757 73.1987Z"
        fill="#EDEFF1"
      />
      <path
        d="M51.3423 73.4395V90.8613C51.3423 91.6419 50.8689 92.3478 50.1465 92.6384C48.5438 93.2778 45.4215 93.5269 41.2944 89.0594C40.8127 88.5362 40.5387 87.847 40.5387 87.1328V73.4312H51.3423V73.4395Z"
        fill="#E4A696"
      />
      <path
        d="M51.3426 75.8974V88.9514C51.3426 88.9514 43.9354 89.5244 42.1168 78.3471V75.8974H51.3426Z"
        fill="#D28070"
      />
      <path
        d="M39.0685 68.5151C39.0685 68.6729 39.0685 68.8224 39.0851 68.9718C39.0768 68.9801 39.0768 68.9884 39.0851 68.9968C39.301 70.7489 39.7245 71.8949 39.7245 71.8949C39.7245 71.8949 39.8408 72.3184 40.0733 73.0076C40.0816 73.0325 40.0982 73.0574 40.1065 73.0823C41.3023 76.57 45.4045 86.4934 53.2186 86.1031C60.2023 85.7543 60.4597 74.494 60.1026 68.5815V68.5151C60.0611 67.967 60.0279 67.4688 59.9864 67.0287C59.9864 66.9872 59.9781 66.954 59.9781 66.9124C59.9781 66.8958 59.9781 66.8792 59.9698 66.8626C59.1809 61.847 54.8296 58.0022 49.5814 58.0022C47.3559 58.0022 45.2882 58.6914 43.5942 59.8789C40.8622 61.7805 39.0685 64.9361 39.0685 68.5151Z"
        fill="#E4A696"
      />
      <path
        d="M54.7304 77.8157H55.2204C55.5608 77.8157 55.8764 77.6496 56.0757 77.3673C56.2667 77.0849 56.3165 76.7279 56.1919 76.4123L54.938 71.4299C54.9131 71.3219 54.7886 71.2472 54.6889 71.2804C54.581 71.3053 54.5062 71.4216 54.5394 71.5295L55.8017 76.5369C55.8847 76.7528 55.8598 76.9604 55.7352 77.1348C55.6107 77.3092 55.428 77.4005 55.2204 77.4005H54.7304C54.6142 77.4005 54.5228 77.4918 54.5228 77.6081C54.5228 77.7244 54.6142 77.8157 54.7304 77.8157Z"
        fill="#D58270"
      />
      <path
        d="M51.8989 78.1562C51.8989 78.1562 51.8656 78.1562 51.849 78.1562C51.7411 78.1811 51.6747 78.2973 51.6996 78.4053C51.7079 78.4468 51.9653 79.4516 52.804 79.8419C53.6676 80.2405 54.5894 79.5429 54.6309 79.518C54.7222 79.4516 54.7388 79.3187 54.6724 79.2274C54.606 79.136 54.4731 79.1194 54.3818 79.1859C54.3818 79.1859 53.6178 79.7588 52.9867 79.4682C52.3307 79.1609 52.1148 78.3222 52.1065 78.3139C52.0815 78.2226 51.9985 78.1562 51.9072 78.1562H51.8989Z"
        fill="#D58270"
      />
      <path
        d="M48.9089 70.4002C48.9089 70.4002 48.992 70.4002 49.0335 70.3836L52.0977 69.412C52.3136 69.3456 52.4381 69.1131 52.3717 68.8889C52.3053 68.6729 52.0728 68.5484 51.8486 68.6148L48.7844 69.5864C48.5685 69.6528 48.4439 69.8853 48.5103 70.1095C48.5685 70.2839 48.7262 70.4002 48.9089 70.4002Z"
        fill="#D34F16"
      />
      <path
        d="M60.0695 70.4001C60.2439 70.4001 60.41 70.2838 60.4681 70.1095C60.5345 69.8935 60.4183 69.661 60.1941 69.5863L57.1299 68.6147C56.9057 68.5483 56.6815 68.6646 56.6067 68.8888C56.5403 69.1047 56.6566 69.3372 56.8808 69.4119L59.945 70.3835C59.9865 70.4001 60.028 70.4001 60.0695 70.4001Z"
        fill="#D34F16"
      />
      <path
        d="M50.7274 62.0462C50.7274 62.0462 48.9669 62.5113 48.369 65.044C47.821 67.3525 44.7568 67.5601 44.7568 67.5601C44.7568 67.5601 42.8635 68.3158 42.415 70.4831C41.9666 72.6505 38.8028 69.6859 39.2346 66.6633C39.6664 63.6406 47.4058 57.4209 50.7274 62.0462Z"
        fill="#A53007"
      />
      <path
        d="M51.9816 61.9716C51.9816 61.9716 48.6434 61.6394 48.5022 64.4379C48.361 67.2363 46.7251 67.419 44.7571 67.5602C42.789 67.7014 42.3323 68.5982 42.4153 70.4832C42.5482 73.564 39.4259 73.2318 42.1247 76.6199C44.4166 79.5014 43.1461 81.8182 43.1461 83.6783C43.1461 86.1363 44.2339 85.3391 44.9564 88.1293C45.3882 89.7901 44.3585 91.3014 43.3288 92.6716C42.7226 93.4771 42.3655 94.8888 43.7689 97.2139C46.0193 100.951 40.2563 102.138 37.8647 97.7786C35.4732 93.419 35.224 94.0252 30.881 92.2564C25.4917 90.0641 26.2474 84.9073 29.2451 82.4161C32.2429 79.9249 28.7303 76.8607 30.2748 74.5273C31.8194 72.1938 34.2358 71.9115 34.3521 68.5816C34.485 64.6289 32.7577 61.955 38.7948 59.9122C41.0618 59.1482 41.7759 54.9962 47.705 56.7068"
        fill="#D34F16"
      />
      <path
        d="M41.6961 76.5507C42.8407 76.2508 43.404 74.6159 42.9542 72.899C42.5044 71.1821 41.2119 70.0333 40.0673 70.3332C38.9226 70.633 38.3594 72.2679 38.8092 73.9849C39.2589 75.7018 40.5515 76.8505 41.6961 76.5507Z"
        fill="#E4A696"
      />
      <path
        d="M42.1168 73.946C42.1168 73.946 42.1417 73.946 42.15 73.946C42.2579 73.9294 42.3327 73.838 42.3244 73.7301C42.2911 72.8332 41.8178 71.1392 40.3231 71.1392C40.2068 71.1392 40.1155 71.2306 40.1155 71.3468C40.1155 71.4631 40.2068 71.5544 40.3231 71.5544C41.1701 71.5544 41.5687 72.252 41.7514 72.8582C41.4856 72.6672 41.1203 72.5509 40.6469 72.6589C40.539 72.6838 40.4642 72.7917 40.4892 72.908C40.5141 73.0242 40.622 73.0907 40.7383 73.0658C41.6517 72.8665 41.9092 73.755 41.9175 73.7965C41.9424 73.8879 42.0254 73.946 42.1168 73.946Z"
        fill="#D58270"
      />
      <path
        d="M51.3422 73.2402C51.6907 73.2402 51.9733 72.8499 51.9733 72.3683C51.9733 71.8868 51.6907 71.4964 51.3422 71.4964C50.9936 71.4964 50.7111 71.8868 50.7111 72.3683C50.7111 72.8499 50.9936 73.2402 51.3422 73.2402Z"
        fill="#202124"
      />
      <path
        d="M52.8121 72.2022C52.2142 71.1808 50.4869 71.1891 49.8807 72.2022C50.9021 71.7289 51.799 71.7123 52.8121 72.2022Z"
        fill="#202124"
      />
      <path
        d="M57.903 73.2402C58.2515 73.2402 58.5341 72.8499 58.5341 72.3683C58.5341 71.8868 58.2515 71.4964 57.903 71.4964C57.5544 71.4964 57.2719 71.8868 57.2719 72.3683C57.2719 72.8499 57.5544 73.2402 57.903 73.2402Z"
        fill="#202124"
      />
      <path
        d="M59.3729 72.2022C58.775 71.1808 57.0477 71.1891 56.4415 72.2022C57.4629 71.7288 58.3598 71.7122 59.3729 72.2022Z"
        fill="#202124"
      />
      <path
        d="M47.6552 74.5354C47.7699 74.5354 47.8628 74.4424 47.8628 74.3278C47.8628 74.2131 47.7699 74.1202 47.6552 74.1202C47.5406 74.1202 47.4476 74.2131 47.4476 74.3278C47.4476 74.4424 47.5406 74.5354 47.6552 74.5354Z"
        fill="#D58270"
      />
      <path
        d="M48.4937 75.1748C48.5671 75.1748 48.6266 75.1153 48.6266 75.0419C48.6266 74.9685 48.5671 74.909 48.4937 74.909C48.4203 74.909 48.3608 74.9685 48.3608 75.0419C48.3608 75.1153 48.4203 75.1748 48.4937 75.1748Z"
        fill="#D58270"
      />
      <path
        d="M49.2079 74.6185C49.2767 74.6185 49.3325 74.5627 49.3325 74.4939C49.3325 74.4251 49.2767 74.3694 49.2079 74.3694C49.1391 74.3694 49.0834 74.4251 49.0834 74.4939C49.0834 74.5627 49.1391 74.6185 49.2079 74.6185Z"
        fill="#D58270"
      />
      <path
        d="M49.5486 75.507C49.6404 75.507 49.7147 75.4326 49.7147 75.3409C49.7147 75.2492 49.6404 75.1748 49.5486 75.1748C49.4569 75.1748 49.3826 75.2492 49.3826 75.3409C49.3826 75.4326 49.4569 75.507 49.5486 75.507Z"
        fill="#D58270"
      />
      <path
        d="M53.2353 73.8712C53.3087 73.8712 53.3681 73.8117 53.3681 73.7383C53.3681 73.6649 53.3087 73.6054 53.2353 73.6054C53.1619 73.6054 53.1024 73.6649 53.1024 73.7383C53.1024 73.8117 53.1619 73.8712 53.2353 73.8712Z"
        fill="#D58270"
      />
      <path
        d="M54.3648 73.4393C54.4565 73.4393 54.5309 73.3649 54.5309 73.2732C54.5309 73.1815 54.4565 73.1071 54.3648 73.1071C54.2731 73.1071 54.1987 73.1815 54.1987 73.2732C54.1987 73.3649 54.2731 73.4393 54.3648 73.4393Z"
        fill="#D58270"
      />
      <path
        d="M50.504 74.4939C50.5957 74.4939 50.6701 74.4196 50.6701 74.3278C50.6701 74.2361 50.5957 74.1617 50.504 74.1617C50.4122 74.1617 50.3379 74.2361 50.3379 74.3278C50.3379 74.4196 50.4122 74.4939 50.504 74.4939Z"
        fill="#D58270"
      />
      <path
        d="M51.4834 74.9009C51.5522 74.9009 51.608 74.8451 51.608 74.7763C51.608 74.7075 51.5522 74.6518 51.4834 74.6518C51.4147 74.6518 51.3589 74.7075 51.3589 74.7763C51.3589 74.8451 51.4147 74.9009 51.4834 74.9009Z"
        fill="#D58270"
      />
      <path
        d="M50.8189 75.5568C50.8785 75.5568 50.9268 75.5084 50.9268 75.4488C50.9268 75.3892 50.8785 75.3409 50.8189 75.3409C50.7593 75.3409 50.7109 75.3892 50.7109 75.4488C50.7109 75.5084 50.7593 75.5568 50.8189 75.5568Z"
        fill="#D58270"
      />
      <path
        d="M54.0164 74.3444C54.076 74.3444 54.1244 74.2961 54.1244 74.2365C54.1244 74.1768 54.076 74.1285 54.0164 74.1285C53.9568 74.1285 53.9084 74.1768 53.9084 74.2365C53.9084 74.2961 53.9568 74.3444 54.0164 74.3444Z"
        fill="#D58270"
      />
      <path
        d="M51.8569 74.1368C51.9165 74.1368 51.9648 74.0885 51.9648 74.0289C51.9648 73.9692 51.9165 73.9209 51.8569 73.9209C51.7972 73.9209 51.7489 73.9692 51.7489 74.0289C51.7489 74.0885 51.7972 74.1368 51.8569 74.1368Z"
        fill="#D58270"
      />
      <path
        d="M52.596 75.1665C52.6648 75.1665 52.7206 75.1107 52.7206 75.0419C52.7206 74.9731 52.6648 74.9174 52.596 74.9174C52.5272 74.9174 52.4714 74.9731 52.4714 75.0419C52.4714 75.1107 52.5272 75.1665 52.596 75.1665Z"
        fill="#D58270"
      />
      <path
        d="M52.7043 74.4525C52.7639 74.4525 52.8122 74.4041 52.8122 74.3445C52.8122 74.2849 52.7639 74.2366 52.7043 74.2366C52.6446 74.2366 52.5963 74.2849 52.5963 74.3445C52.5963 74.4041 52.6446 74.4525 52.7043 74.4525Z"
        fill="#D58270"
      />
      <path
        d="M48.785 75.9057C48.8446 75.9057 48.8929 75.8573 48.8929 75.7977C48.8929 75.7381 48.8446 75.6898 48.785 75.6898C48.7253 75.6898 48.677 75.7381 48.677 75.7977C48.677 75.8573 48.7253 75.9057 48.785 75.9057Z"
        fill="#D58270"
      />
      <path
        d="M56.2584 74.2032C56.3501 74.2032 56.4244 74.1288 56.4244 74.0371C56.4244 73.9454 56.3501 73.871 56.2584 73.871C56.1666 73.871 56.0923 73.9454 56.0923 74.0371C56.0923 74.1288 56.1666 74.2032 56.2584 74.2032Z"
        fill="#D58270"
      />
      <path
        d="M59.671 74.9838C59.7856 74.9838 59.8786 74.8909 59.8786 74.7762C59.8786 74.6616 59.7856 74.5686 59.671 74.5686C59.5563 74.5686 59.4634 74.6616 59.4634 74.7762C59.4634 74.8909 59.5563 74.9838 59.671 74.9838Z"
        fill="#D58270"
      />
      <path
        d="M53.6012 74.8841C53.6609 74.8841 53.7092 74.8358 53.7092 74.7761C53.7092 74.7165 53.6609 74.6682 53.6012 74.6682C53.5416 74.6682 53.4933 74.7165 53.4933 74.7761C53.4933 74.8358 53.5416 74.8841 53.6012 74.8841Z"
        fill="#D58270"
      />
      <path
        d="M56.7233 74.9423C56.7829 74.9423 56.8313 74.894 56.8313 74.8343C56.8313 74.7747 56.7829 74.7264 56.7233 74.7264C56.6637 74.7264 56.6154 74.7747 56.6154 74.8343C56.6154 74.894 56.6637 74.9423 56.7233 74.9423Z"
        fill="#D58270"
      />
      <path
        d="M58.5339 75.2578C58.6256 75.2578 58.7 75.1835 58.7 75.0917C58.7 75 58.6256 74.9257 58.5339 74.9257C58.4422 74.9257 58.3678 75 58.3678 75.0917C58.3678 75.1835 58.4422 75.2578 58.5339 75.2578Z"
        fill="#D58270"
      />
      <path
        d="M57.6952 74.6185C57.764 74.6185 57.8198 74.5627 57.8198 74.4939C57.8198 74.4251 57.764 74.3694 57.6952 74.3694C57.6264 74.3694 57.5707 74.4251 57.5707 74.4939C57.5707 74.5627 57.6264 74.6185 57.6952 74.6185Z"
        fill="#D58270"
      />
      <path
        d="M58.9153 74.2199C58.9749 74.2199 59.0233 74.1716 59.0233 74.112C59.0233 74.0524 58.9749 74.004 58.9153 74.004C58.8557 74.004 58.8074 74.0524 58.8074 74.112C58.8074 74.1716 58.8557 74.2199 58.9153 74.2199Z"
        fill="#D58270"
      />
      <path
        d="M57.4954 75.4821C57.555 75.4821 57.6034 75.4338 57.6034 75.3742C57.6034 75.3146 57.555 75.2662 57.4954 75.2662C57.4358 75.2662 57.3875 75.3146 57.3875 75.3742C57.3875 75.4338 57.4358 75.4821 57.4954 75.4821Z"
        fill="#D58270"
      />
      <path
        d="M51.9822 61.9716C51.9822 61.9716 52.0071 56.9062 57.2802 57.994C62.5532 59.0818 59.9707 66.8544 59.9707 66.8544C59.9707 66.8544 58.5424 57.5539 51.9822 61.9716Z"
        fill="#A53007"
      />
      <path
        d="M47.6971 56.7236C47.6971 56.7236 55.204 52.9037 59.3726 59.1068C59.3726 59.1068 54.6975 56.1755 51.982 61.9717L47.7054 56.7236H47.6971Z"
        fill="#D34F16"
      />
      <path
        d="M61.9216 72.4847C61.9216 72.4847 61.9299 72.518 61.9299 72.5346C61.9465 72.518 61.9798 72.5013 62.0213 72.5013L62.3451 72.518L61.9216 72.4847Z"
        fill="#601802"
      />
      <path
        d="M61.9379 73.0161C61.9379 73.0161 61.9877 73.0493 62.0209 73.0493H62.0292V73.0244H61.9379V73.0161Z"
        fill="#601802"
      />
      <path
        d="M42.2743 71.5298L46.8664 72.4681C46.8664 72.4681 46.8996 72.4764 46.9162 72.4764H47.0076L47.6636 72.5096C47.6553 72.6176 47.647 72.7255 47.647 72.8418C47.6387 74.6272 49.067 76.1302 50.8274 76.1966C52.5879 76.2631 54.0245 74.868 54.0245 73.0826C54.0245 72.6342 53.9415 72.1941 53.7754 71.7955C54.0577 71.6875 54.3899 71.6377 54.7553 71.646C55.1788 71.6626 55.5773 71.7706 55.8929 71.945C55.7434 72.3103 55.6604 72.7172 55.6604 73.1407C55.6604 74.9261 57.0887 76.4291 58.8491 76.4956C60.6096 76.562 62.0379 75.1669 62.0462 73.3816C62.0462 73.2653 62.0462 73.1574 62.0296 73.0494H62.0213C62.0213 73.0494 61.9549 73.0411 61.9382 73.0162H62.0296V73.0494L62.8019 73.0826C62.8683 73.0826 62.9264 73.0245 62.9264 72.9581V72.6674C62.9347 72.5927 62.8766 72.5345 62.8019 72.5345L62.3451 72.5179L62.0213 72.5013C62.0213 72.5013 61.9466 72.5179 61.9299 72.5345C61.9299 72.5179 61.9299 72.5013 61.9216 72.4847C61.548 71.1229 60.319 70.0849 58.8574 70.0267C57.6367 69.9769 56.5738 70.6329 56.0424 71.6377C55.7102 71.4218 55.2535 71.2723 54.7553 71.2557C54.3234 71.2391 53.9331 71.3222 53.6176 71.4716C53.0695 70.4668 52.0315 69.761 50.844 69.7195C49.3742 69.6613 48.1369 70.6246 47.7632 71.9865C47.7466 71.9699 47.7217 71.9616 47.6968 71.9616L46.9162 71.9283H46.8913L41.9089 70.9485C41.8259 71.1146 42.3241 71.3554 42.2743 71.5298ZM56.0424 73.1573C56.0424 71.5796 57.3046 70.3506 58.8574 70.4087C60.0947 70.4585 61.1494 71.3139 61.523 72.4515H61.4234L60.2027 72.3435C60.2027 72.5179 60.2027 72.6923 60.1944 72.875L61.4068 72.9747L61.6393 72.9913C61.6559 73.1158 61.6642 73.2404 61.6642 73.3649C61.6642 74.9427 60.402 76.1717 58.8491 76.1136C57.2963 76.0555 56.0424 74.7351 56.0424 73.1573ZM48.0207 72.8501C48.029 71.2806 49.2912 70.0516 50.844 70.1098C52.3969 70.1679 53.6508 71.4882 53.6508 73.066C53.6425 74.6438 52.3803 75.8728 50.8274 75.8146C49.2746 75.7565 48.0207 74.4279 48.0207 72.8501Z"
        fill="#601802"
      />
      <path
        d="M61.9379 73.0161C61.9379 73.0161 61.9877 73.0493 62.0209 73.0493H62.0292V73.0244H61.9379V73.0161Z"
        fill="#601802"
      />
      <path
        d="M90.5456 127.964H128.063C128.329 127.964 128.561 127.806 128.653 127.557L138.867 100.959C139.025 100.544 138.717 100.095 138.277 100.095H100.76C100.494 100.095 100.261 100.253 100.17 100.502L89.956 127.1C89.7982 127.515 90.1055 127.964 90.5456 127.964Z"
        fill="#A4C9EB"
      />
      <path
        d="M70.591 131.377H127.399C128.087 131.377 128.645 130.819 128.645 130.131V128.479C128.645 127.791 128.087 127.233 127.399 127.233H70.591C69.903 127.233 69.3454 127.791 69.3454 128.479V130.131C69.3454 130.819 69.903 131.377 70.591 131.377Z"
        fill="#6FAAE3"
      />
      <path
        d="M116.389 115.911C117.7 114.828 118.164 113.224 117.425 112.329C116.686 111.435 115.024 111.589 113.712 112.672C112.4 113.756 111.936 115.36 112.675 116.254C113.415 117.149 115.077 116.995 116.389 115.911Z"
        fill="#EDEFF1"
      />
      <path
        d="M8.74246 141.001L288.647 141.001C289.564 141.001 290.308 140.258 290.308 139.34V133.013C290.308 132.096 289.564 131.352 288.647 131.352L8.74246 131.352C7.82523 131.352 7.08167 132.096 7.08167 133.013V139.34C7.08167 140.258 7.82523 141.001 8.74246 141.001Z"
        fill="#EDEFF1"
      />
      <path
        d="M143.077 126.535L143.492 131.003C143.508 131.202 143.699 131.352 143.924 131.352H150.193C150.417 131.352 150.6 131.202 150.625 131.003L151.04 126.535H143.093H143.077Z"
        fill="#A6CBED"
      />
      <path
        d="M151.406 117.384H142.703C142.454 117.384 142.255 117.575 142.271 117.8L142.678 122.201H151.422L151.829 117.8C151.846 117.575 151.655 117.384 151.398 117.384H151.406Z"
        fill="#A6CBED"
      />
      <path d="M142.678 122.209L143.077 126.536H151.024L151.423 122.209H142.678Z" fill="#EFF1F3" />
      <path
        d="M151.173 114.968H142.927C142.588 114.968 142.312 115.243 142.312 115.583V116.056C142.312 116.395 142.588 116.67 142.927 116.67H151.173C151.512 116.67 151.787 116.395 151.787 116.056V115.583C151.787 115.243 151.512 114.968 151.173 114.968Z"
        fill="#6EACE5"
      />
      <path d="M142.346 116.396L151.787 115.815V116.662L142.346 117.077V116.396Z" fill="#228BE6" />
      <path
        d="M152.02 116.396H142.089C141.749 116.396 141.474 116.671 141.474 117.011V117.484C141.474 117.824 141.749 118.099 142.089 118.099H152.02C152.36 118.099 152.635 117.824 152.635 117.484V117.011C152.635 116.671 152.36 116.396 152.02 116.396Z"
        fill="#6EACE5"
      />
      <path
        d="M146.938 124.327L146.996 124.302C147.254 124.194 147.436 123.97 147.511 123.712C147.511 123.696 147.511 123.679 147.494 123.671C147.478 123.654 147.461 123.638 147.436 123.629C147.137 123.43 146.689 123.579 146.44 123.961C146.241 124.269 146.216 124.626 146.365 124.858C146.382 124.883 146.432 124.883 146.44 124.85C146.523 124.617 146.706 124.426 146.938 124.327Z"
        fill="#228BE6"
      />
      <path
        d="M147.735 123.878C147.735 123.878 147.669 123.853 147.661 123.887C147.578 124.127 147.403 124.318 147.154 124.426L147.096 124.451C146.847 124.559 146.664 124.775 146.589 125.024C146.589 125.041 146.589 125.057 146.598 125.066C146.614 125.082 146.639 125.099 146.656 125.116C146.955 125.315 147.403 125.165 147.652 124.783C147.86 124.476 147.876 124.111 147.727 123.878H147.735Z"
        fill="#228BE6"
      />
      <path
        d="M217.721 76.296C217.397 77.226 216.891 78.0315 216.251 78.7041L192.585 107.428L182.047 98.7335L205.639 70.3337C205.639 70.3337 205.656 70.3005 205.672 70.2922C207.341 67.7594 210.58 66.5886 213.578 67.6432C217.115 68.8888 218.967 72.7585 217.721 76.296Z"
        fill="#59332F"
      />
      <path
        d="M193.257 106.34C191.638 109.72 187.577 111.14 184.198 109.52C183.558 109.205 182.977 108.815 182.479 108.341C182.346 108.217 182.213 108.084 182.097 107.951C182.097 107.951 182.08 107.943 182.072 107.934L181.067 106.465L168.769 88.4531L173.054 84.4423L191.92 98.4844L191.854 98.5508C193.889 100.527 194.536 103.65 193.241 106.348L193.257 106.34Z"
        fill="#59332F"
      />
      <path
        d="M171.377 90.4627C172.863 90.5789 174.275 89.6489 174.698 88.1541C175.047 86.9085 174.599 85.6214 173.652 84.8491L173.278 84.5834L168.105 80.913C167.964 80.8217 167.822 80.7635 167.656 80.722L162.948 79.9414C162.599 79.8335 162.217 80.0245 162.109 80.3816C162.001 80.7386 162.201 81.104 162.558 81.2203L166.693 83.0389L166.676 83.0638L163.106 84.1101C163.023 84.0852 162.923 84.0436 162.84 84.0187L155.192 81.9095C155.092 81.8763 154.976 81.8597 154.868 81.868C154.619 81.8846 154.386 82.0341 154.279 82.2832C154.137 82.6153 154.279 82.9973 154.594 83.1717L160.465 88.478C160.814 88.7853 161.229 89.0095 161.686 89.0925C161.785 89.1174 161.902 89.1174 162.01 89.1257V89.1423L171.385 90.4627H171.377Z"
        fill="#59332F"
      />
      <path
        d="M247.5 141.126H202.658L201.845 129.766L201.712 127.964L201.687 127.648C201.687 127.648 201.678 127.582 201.678 127.549C201.67 127.499 201.67 127.441 201.67 127.391L201.62 126.635C201.62 126.635 201.612 126.569 201.612 126.536C201.604 126.278 201.595 126.021 201.595 125.772C201.571 121.711 202.55 118.489 203.14 116.911C203.389 116.264 204.004 115.848 204.693 115.848H240.118C240.641 115.848 241.148 116.081 241.447 116.513C244.403 120.673 245.532 126.461 245.898 128.994C245.914 129.085 245.914 129.193 245.906 129.284V129.342H245.914L246.022 130.14L246.155 131.136L246.537 133.993L246.927 136.866L247.5 141.126Z"
        fill="#A4C9EB"
      />
      <path
        d="M201.612 126.536L201.587 126.187C201.587 126.046 201.587 125.913 201.595 125.772C201.595 126.021 201.603 126.278 201.612 126.536Z"
        fill="#6EACE5"
      />
      <path
        d="M188.964 99.373C188.964 99.373 187.436 102.703 189.421 104.895C191.406 107.087 190.966 109.072 190.966 109.072C190.966 109.072 192.61 108.018 194.121 105.742C195.632 103.467 196.911 103.16 196.911 103.16L188.956 99.373"
        fill="#B76B5C"
      />
      <path
        d="M196.031 104.945L184.555 96.2508C183.783 95.6612 183.675 94.5402 184.323 93.8177L206.328 69.4371C207.865 66.9209 210.904 65.5757 213.918 66.2815C217.398 67.1036 219.656 70.3754 219.299 73.8382C219.224 74.3946 219.1 74.951 218.917 75.499C218.66 76.2381 218.286 76.9024 217.804 77.4837C217.746 77.575 217.672 77.6581 217.597 77.7411L198.373 104.596C197.825 105.36 196.762 105.518 196.023 104.953L196.031 104.945Z"
        fill="#6EACE5"
      />
      <path
        d="M203.107 117.119H242.136L252.383 77.7328C253.903 72.6175 251.146 67.1949 246.163 65.5258C242.692 64.3632 237.66 63.5328 230.377 63.5328C219.756 63.5328 213.429 65.2186 209.675 67.1036C206.279 68.8142 204.302 72.5012 204.743 76.3294L203.107 117.119Z"
        fill="#A4C9EB"
      />
      <path
        d="M212.606 59.3145C211.942 58.6336 211.759 57.6205 212.149 56.7486L212.897 55.0629L214.283 51.9406L215.67 55.0629L216.418 56.7486C216.8 57.6205 216.617 58.6336 215.961 59.3145C215.047 60.2612 213.536 60.2529 212.614 59.3145H212.606Z"
        fill="#6EACE5"
      />
      <path
        d="M212.938 57.853C212.407 57.3049 212.266 56.4911 212.573 55.7936L213.171 54.44L214.283 51.9322L215.396 54.44L215.994 55.7936C216.301 56.4911 216.16 57.3049 215.629 57.853C214.898 58.6087 213.686 58.6087 212.946 57.853H212.938Z"
        fill="#A4C9EB"
      />
      <path
        d="M213.345 56.0843C212.971 55.7023 212.872 55.1293 213.088 54.6394L213.511 53.6927L214.292 51.9406L215.072 53.6927L215.496 54.6394C215.712 55.1293 215.612 55.694 215.238 56.0843C214.724 56.6157 213.877 56.6157 213.362 56.0843H213.345Z"
        fill="#6EACE5"
      />
      <path
        d="M220.844 49.1918V66.6137C220.844 67.3943 221.317 68.1001 222.039 68.3908C223.642 69.0302 226.764 69.2793 230.892 64.8117C231.373 64.2886 231.647 63.5994 231.647 62.8852V49.1835H220.844V49.1918Z"
        fill="#77463F"
      />
      <path
        d="M220.844 51.6498V64.7038C220.844 64.7038 228.251 65.2768 230.069 54.0995V51.6498H220.844Z"
        fill="#59332F"
      />
      <path
        d="M233.117 44.2675C233.117 44.4253 233.117 44.5747 233.1 44.7242C233.108 44.7325 233.108 44.7408 233.1 44.7491C232.884 46.5013 232.461 47.6472 232.461 47.6472C232.461 47.6472 232.344 48.0707 232.112 48.76C232.104 48.7849 232.087 48.8098 232.079 48.8347C230.883 52.3224 226.781 62.2457 218.966 61.8555C211.983 61.5067 211.725 50.2464 212.082 44.3339V44.2675C212.124 43.7194 212.157 43.2212 212.199 42.7811C212.199 42.7396 212.207 42.7063 212.207 42.6648C212.207 42.6482 212.207 42.6316 212.215 42.615C213.004 37.5993 217.356 33.7546 222.604 33.7546C228.408 33.7546 233.117 38.463 233.117 44.2675Z"
        fill="#77463F"
      />
      <path
        d="M217.455 53.5598H216.965C216.625 53.5598 216.309 53.3937 216.11 53.1113C215.919 52.829 215.869 52.4719 215.993 52.1564L217.247 47.1739C217.272 47.066 217.397 46.9913 217.497 47.0245C217.604 47.0494 217.679 47.1656 217.646 47.2736L216.384 52.2809C216.301 52.4968 216.326 52.7044 216.45 52.8788C216.575 53.0532 216.757 53.1446 216.965 53.1446H217.455C217.571 53.1446 217.663 53.2359 217.663 53.3522C217.663 53.4684 217.571 53.5598 217.455 53.5598Z"
        fill="#59332F"
      />
      <path
        d="M217.414 38.0645C217.414 38.0645 216.857 41.2948 219.166 42.1086C221.474 42.9224 220.162 45.6295 222.903 46.4848C225.643 47.3401 226.573 45.5714 228.167 46.4848C229.762 47.3983 230.958 45.6295 230.958 45.6295L218.02 37.4417L217.414 38.0645Z"
        fill="#B76B5C"
      />
      <path
        d="M223.277 46.1526C223.277 46.1526 223.194 46.1526 223.152 46.136L220.088 45.1644C219.872 45.098 219.747 44.8655 219.814 44.6413C219.88 44.4254 220.113 44.3008 220.337 44.3672L223.401 45.3388C223.617 45.4052 223.742 45.6377 223.675 45.862C223.617 46.0363 223.459 46.1526 223.277 46.1526Z"
        fill="#202124"
      />
      <path
        d="M212.116 46.1525C211.941 46.1525 211.775 46.0362 211.717 45.8618C211.651 45.6459 211.767 45.4134 211.991 45.3387L215.055 44.3671C215.28 44.3007 215.504 44.4169 215.579 44.6411C215.645 44.857 215.529 45.0896 215.305 45.1643L212.24 46.1359C212.199 46.1525 212.157 46.1525 212.116 46.1525Z"
        fill="#202124"
      />
      <path
        d="M213.511 38.3882C214.791 38.3882 215.828 37.351 215.828 36.0714C215.828 34.7919 214.791 33.7546 213.511 33.7546C212.231 33.7546 211.194 34.7919 211.194 36.0714C211.194 37.351 212.231 38.3882 213.511 38.3882Z"
        fill="#202124"
      />
      <path
        d="M234.105 45.9948C235.059 45.9948 235.832 45.2215 235.832 44.2676C235.832 43.3136 235.059 42.5403 234.105 42.5403C233.151 42.5403 232.378 43.3136 232.378 44.2676C232.378 45.2215 233.151 45.9948 234.105 45.9948Z"
        fill="#202124"
      />
      <path
        d="M213.096 35.1414C214.041 35.1414 214.807 34.3755 214.807 33.4308C214.807 32.486 214.041 31.7201 213.096 31.7201C212.151 31.7201 211.385 32.486 211.385 33.4308C211.385 34.3755 212.151 35.1414 213.096 35.1414Z"
        fill="#202124"
      />
      <path
        d="M232.153 48.0707C233.135 48.0707 233.93 47.2751 233.93 46.2936C233.93 45.3122 233.135 44.5166 232.153 44.5166C231.172 44.5166 230.376 45.3122 230.376 46.2936C230.376 47.2751 231.172 48.0707 232.153 48.0707Z"
        fill="#202124"
      />
      <path
        d="M232.195 48.0791C232.195 48.0791 235.243 42.5403 232.145 35.7891L232.602 34.228H214.715V35.7393C214.715 35.7393 212.157 37.1344 212.282 42.1002L216.799 37.6409L232.195 48.0874V48.0791Z"
        fill="#A4C9EB"
      />
      <path
        d="M216.791 37.6409L214.284 36.0714C214.284 36.0714 212.075 37.1094 212.274 42.1085L216.791 37.6492V37.6409Z"
        fill="#6EACE5"
      />
      <path
        d="M215.712 34.8175C217.276 34.8175 218.543 33.5497 218.543 31.9859C218.543 30.422 217.276 29.1542 215.712 29.1542C214.148 29.1542 212.88 30.422 212.88 31.9859C212.88 33.5497 214.148 34.8175 215.712 34.8175Z"
        fill="#202124"
      />
      <path
        d="M219.473 33.4308C221.39 33.4308 222.944 31.8767 222.944 29.9597C222.944 28.0427 221.39 26.4886 219.473 26.4886C217.556 26.4886 216.002 28.0427 216.002 29.9597C216.002 31.8767 217.556 33.4308 219.473 33.4308Z"
        fill="#202124"
      />
      <path
        d="M232.154 42.2165C234.071 42.2165 235.625 40.6625 235.625 38.7454C235.625 36.8284 234.071 35.2744 232.154 35.2744C230.237 35.2744 228.683 36.8284 228.683 38.7454C228.683 40.6625 230.237 42.2165 232.154 42.2165Z"
        fill="#202124"
      />
      <path
        d="M226.532 35.9802C228.834 35.9802 230.701 34.1139 230.701 31.8116C230.701 29.5093 228.834 27.643 226.532 27.643C224.23 27.643 222.363 29.5093 222.363 31.8116C222.363 34.1139 224.23 35.9802 226.532 35.9802Z"
        fill="#202124"
      />
      <path
        d="M223.501 30.5493C225.065 30.5493 226.333 29.2816 226.333 27.7177C226.333 26.1538 225.065 24.886 223.501 24.886C221.937 24.886 220.669 26.1538 220.669 27.7177C220.669 29.2816 221.937 30.5493 223.501 30.5493Z"
        fill="#202124"
      />
      <path
        d="M232.378 36.3705C234.295 36.3705 235.849 34.8164 235.849 32.8994C235.849 30.9823 234.295 29.4283 232.378 29.4283C230.461 29.4283 228.907 30.9823 228.907 32.8994C228.907 34.8164 230.461 36.3705 232.378 36.3705Z"
        fill="#202124"
      />
      <path
        d="M221.64 36.8605C223.204 36.8605 224.472 35.5927 224.472 34.0288C224.472 32.4649 223.204 31.1971 221.64 31.1971C220.077 31.1971 218.809 32.4649 218.809 34.0288C218.809 35.5927 220.077 36.8605 221.64 36.8605Z"
        fill="#202124"
      />
      <path
        d="M218.244 36.7607C219.808 36.7607 221.076 35.493 221.076 33.9291C221.076 32.3652 219.808 31.0974 218.244 31.0974C216.681 31.0974 215.413 32.3652 215.413 33.9291C215.413 35.493 216.681 36.7607 218.244 36.7607Z"
        fill="#202124"
      />
      <path
        d="M234.445 38.1308C236.009 38.1308 237.277 36.863 237.277 35.2991C237.277 33.7353 236.009 32.4675 234.445 32.4675C232.881 32.4675 231.614 33.7353 231.614 35.2991C231.614 36.863 232.881 38.1308 234.445 38.1308Z"
        fill="#202124"
      />
      <path
        d="M214.948 36.221C215.97 36.221 216.799 35.3919 216.799 34.3692C216.799 33.3464 215.97 32.5174 214.948 32.5174C213.925 32.5174 213.096 33.3464 213.096 34.3692C213.096 35.3919 213.925 36.221 214.948 36.221Z"
        fill="#202124"
      />
      <path
        d="M224.448 37.6162C225.301 37.6162 225.992 36.9247 225.992 36.0716C225.992 35.2186 225.301 34.5271 224.448 34.5271C223.595 34.5271 222.903 35.2186 222.903 36.0716C222.903 36.9247 223.595 37.6162 224.448 37.6162Z"
        fill="#202124"
      />
      <path
        d="M227.869 39.8167C228.722 39.8167 229.414 39.1252 229.414 38.2721C229.414 37.4191 228.722 36.7276 227.869 36.7276C227.016 36.7276 226.325 37.4191 226.325 38.2721C226.325 39.1252 227.016 39.8167 227.869 39.8167Z"
        fill="#202124"
      />
      <path
        d="M235.584 39.7086C236.437 39.7086 237.128 39.0171 237.128 38.1641C237.128 37.311 236.437 36.6195 235.584 36.6195C234.731 36.6195 234.039 37.311 234.039 38.1641C234.039 39.0171 234.731 39.7086 235.584 39.7086Z"
        fill="#202124"
      />
      <path
        d="M227.421 30.5577C228.751 30.5577 229.829 29.4795 229.829 28.1495C229.829 26.8195 228.751 25.7413 227.421 25.7413C226.091 25.7413 225.013 26.8195 225.013 28.1495C225.013 29.4795 226.091 30.5577 227.421 30.5577Z"
        fill="#202124"
      />
      <path
        d="M230.776 31.9527C232.106 31.9527 233.184 30.8745 233.184 29.5445C233.184 28.2145 232.106 27.1364 230.776 27.1364C229.446 27.1364 228.367 28.2145 228.367 29.5445C228.367 30.8745 229.446 31.9527 230.776 31.9527Z"
        fill="#202124"
      />
      <path
        d="M228.973 37.4416C229.826 37.4416 230.517 36.7501 230.517 35.8971C230.517 35.044 229.826 34.3525 228.973 34.3525C228.12 34.3525 227.428 35.044 227.428 35.8971C227.428 36.7501 228.12 37.4416 228.973 37.4416Z"
        fill="#202124"
      />
      <path
        d="M226.399 38.3884C227.252 38.3884 227.944 37.6969 227.944 36.8438C227.944 35.9908 227.252 35.2993 226.399 35.2993C225.546 35.2993 224.854 35.9908 224.854 36.8438C224.854 37.6969 225.546 38.3884 226.399 38.3884Z"
        fill="#202124"
      />
      <path
        d="M232.054 43.5783C233.971 43.5783 235.525 42.0243 235.525 40.1072C235.525 38.1902 233.971 36.6361 232.054 36.6361C230.137 36.6361 228.583 38.1902 228.583 40.1072C228.583 42.0243 230.137 43.5783 232.054 43.5783Z"
        fill="#202124"
      />
      <path
        d="M233.384 49.7393C233.834 48.0223 233.27 46.3874 232.126 46.0876C230.981 45.7877 229.689 46.9365 229.239 48.6534C228.789 50.3703 229.352 52.0052 230.497 52.3051C231.641 52.6049 232.934 51.4562 233.384 49.7393Z"
        fill="#77463F"
      />
      <path
        d="M230.069 49.6984C230.069 49.6984 230.044 49.6984 230.036 49.6984C229.937 49.6818 229.853 49.5904 229.862 49.4825C229.895 48.5857 230.368 46.8916 231.863 46.8916C231.979 46.8916 232.071 46.983 232.071 47.0992C232.071 47.2155 231.979 47.3068 231.863 47.3068C231.016 47.3068 230.617 48.0044 230.435 48.6106C230.7 48.4196 231.066 48.3033 231.539 48.4113C231.647 48.4362 231.722 48.5441 231.697 48.6604C231.672 48.7767 231.564 48.8431 231.448 48.8182C230.534 48.6189 230.277 49.5074 230.269 49.5489C230.244 49.6403 230.161 49.6984 230.069 49.6984Z"
        fill="#59332F"
      />
      <path
        d="M221.474 48.1208C221.474 48.6024 221.192 48.9927 220.843 48.9927C220.495 48.9927 220.212 48.6024 220.212 48.1208C220.212 47.6392 220.495 47.2489 220.843 47.2489C221.192 47.2489 221.474 47.6392 221.474 48.1208Z"
        fill="#202124"
      />
      <path
        d="M219.374 47.9629C219.972 46.9416 221.699 46.9499 222.305 47.9629C221.284 47.4896 220.387 47.473 219.374 47.9629Z"
        fill="#202124"
      />
      <path
        d="M214.283 48.9928C214.632 48.9928 214.915 48.6024 214.915 48.1208C214.915 47.6393 214.632 47.2489 214.283 47.2489C213.935 47.2489 213.652 47.6393 213.652 48.1208C213.652 48.6024 213.935 48.9928 214.283 48.9928Z"
        fill="#202124"
      />
      <path
        d="M212.814 47.963C213.412 46.9416 215.139 46.9499 215.745 47.963C214.724 47.4896 213.827 47.473 212.814 47.963Z"
        fill="#202124"
      />
      <path
        d="M220.994 53.6593C220.994 53.6593 220.977 53.7838 220.944 53.9748C220.927 54.0579 220.919 54.1243 220.902 54.1907C220.761 54.7803 220.437 55.7021 219.74 56.0176C219.009 56.3415 218.145 55.727 217.68 55.3118C217.473 55.1291 217.34 54.9796 217.34 54.9796L220.994 53.6593Z"
        fill="black"
      />
      <path
        d="M218.951 56.0592C218.951 56.0592 219.3 55.154 220.355 55.4862C220.355 55.4862 219.856 56.3083 218.951 56.0592Z"
        fill="#C61B41"
      />
      <path
        d="M220.994 53.6593C220.994 53.6593 220.977 53.7838 220.944 53.9748C220.927 54.0579 220.919 54.1243 220.902 54.1907L217.68 55.3118C217.473 55.1291 217.34 54.9796 217.34 54.9796L220.994 53.6593Z"
        fill="white"
      />
      <path
        d="M234.586 43.3374C235.806 43.3374 236.795 42.3485 236.795 41.1286C236.795 39.9086 235.806 38.9197 234.586 38.9197C233.367 38.9197 232.378 39.9086 232.378 41.1286C232.378 42.3485 233.367 43.3374 234.586 43.3374Z"
        fill="#202124"
      />
      <path
        d="M233.017 44.9569C233.774 44.9569 234.387 44.3434 234.387 43.5867C234.387 42.83 233.774 42.2166 233.017 42.2166C232.26 42.2166 231.647 42.83 231.647 43.5867C231.647 44.3434 232.26 44.9569 233.017 44.9569Z"
        fill="#202124"
      />
      <path
        d="M229.289 59.3145C228.624 58.6335 228.442 57.6204 228.832 56.7485L229.579 55.0628L230.966 51.9405L232.353 55.0628L233.1 56.7485C233.482 57.6204 233.299 58.6335 232.643 59.3145C231.73 60.2611 230.219 60.2528 229.297 59.3145H229.289Z"
        fill="#6EACE5"
      />
      <path
        d="M229.621 57.853C229.089 57.3049 228.948 56.4911 229.255 55.7936L229.853 54.44L230.966 51.9322L232.079 54.44L232.677 55.7936C232.984 56.4911 232.843 57.3049 232.311 57.853C231.58 58.6086 230.368 58.6086 229.629 57.853H229.621Z"
        fill="#A4C9EB"
      />
      <path
        d="M230.028 56.0842C229.654 55.7022 229.554 55.1292 229.77 54.6393L230.194 53.6926L230.974 51.9405L231.755 53.6926L232.179 54.6393C232.394 55.1292 232.295 55.6939 231.921 56.0842C231.406 56.6157 230.559 56.6157 230.044 56.0842H230.028Z"
        fill="#6EACE5"
      />
      <path
        d="M257.697 102.985C257.722 102.57 257.407 102.213 257 102.188L255.854 102.113L252.549 101.898L231.847 100.569C231.648 100.552 231.457 100.619 231.307 100.752C231.158 100.884 231.066 101.067 231.058 101.266L229.04 132.805C229.023 133.005 229.09 133.196 229.223 133.345C229.356 133.494 229.538 133.586 229.738 133.594L254.891 135.205C255.09 135.222 255.281 135.155 255.43 135.022C255.58 134.89 255.671 134.707 255.679 134.508L257.382 107.951H257.315C257.365 107.852 257.398 107.752 257.407 107.644L257.706 102.969L257.697 102.985Z"
        fill="#E0E0E0"
      />
      <path
        d="M254.176 114.105L233.042 112.751C232.943 112.751 232.86 112.651 232.868 112.552C232.876 112.452 232.968 112.369 233.067 112.377L254.201 113.731C254.301 113.731 254.384 113.831 254.375 113.93C254.367 114.03 254.276 114.113 254.176 114.105Z"
        fill="#E0E0E0"
      />
      <path
        d="M253.96 116.297L232.826 114.943C232.726 114.943 232.643 114.844 232.651 114.744C232.66 114.644 232.751 114.561 232.851 114.57L253.985 115.923C254.084 115.923 254.167 116.023 254.159 116.122C254.151 116.222 254.059 116.305 253.96 116.297Z"
        fill="#E0E0E0"
      />
      <path
        d="M253.86 118.498L232.726 117.144C232.626 117.144 232.543 117.044 232.552 116.945C232.56 116.845 232.651 116.762 232.751 116.77L253.885 118.124C253.984 118.124 254.067 118.223 254.059 118.323C254.051 118.423 253.959 118.506 253.86 118.498Z"
        fill="#E0E0E0"
      />
      <path
        d="M253.644 120.69L232.51 119.336C232.411 119.336 232.328 119.237 232.336 119.137C232.344 119.037 232.436 118.954 232.535 118.962L253.669 120.316C253.769 120.316 253.852 120.416 253.843 120.515C253.835 120.615 253.744 120.698 253.644 120.69Z"
        fill="#E0E0E0"
      />
      <path
        d="M253.578 122.89L232.444 121.537C232.344 121.537 232.261 121.437 232.269 121.338C232.278 121.238 232.369 121.155 232.469 121.163L253.602 122.517C253.702 122.517 253.785 122.616 253.777 122.716C253.769 122.816 253.677 122.899 253.578 122.89Z"
        fill="#E0E0E0"
      />
      <path
        d="M253.362 125.083L232.228 123.729C232.128 123.729 232.045 123.629 232.054 123.53C232.062 123.43 232.153 123.347 232.253 123.355L253.387 124.709C253.486 124.709 253.569 124.809 253.561 124.908C253.553 125.008 253.461 125.091 253.362 125.083Z"
        fill="#E0E0E0"
      />
      <path
        d="M253.237 127.275L232.103 125.921C232.004 125.921 231.92 125.822 231.929 125.722C231.937 125.622 232.028 125.539 232.128 125.548L253.262 126.901C253.362 126.901 253.445 127.001 253.436 127.101C253.428 127.2 253.337 127.283 253.237 127.275Z"
        fill="#E0E0E0"
      />
      <path
        d="M253.013 129.467L231.879 128.114C231.78 128.114 231.697 128.014 231.705 127.914C231.713 127.815 231.805 127.732 231.904 127.74L253.038 129.093C253.138 129.093 253.221 129.193 253.213 129.293C253.204 129.392 253.113 129.475 253.013 129.467Z"
        fill="#E0E0E0"
      />
      <path
        d="M233.415 107.255L233.319 108.755C233.293 109.167 233.605 109.522 234.017 109.548L239.445 109.897C239.857 109.923 240.212 109.611 240.239 109.199L240.335 107.699C240.361 107.287 240.049 106.931 239.637 106.905L234.209 106.557C233.797 106.53 233.442 106.843 233.415 107.255Z"
        fill="#E0E0E0"
      />
      <path
        d="M217.488 114.777C217.264 114.437 217.364 113.972 217.704 113.748L218.659 113.125L221.416 111.331L238.664 100.104C238.83 99.9962 239.029 99.9629 239.22 99.9962C239.411 100.038 239.585 100.154 239.693 100.32L256.8 126.594C256.908 126.76 256.941 126.959 256.908 127.15C256.866 127.341 256.75 127.516 256.584 127.624L235.633 141.267C235.467 141.375 235.267 141.408 235.076 141.375C234.885 141.334 234.711 141.217 234.603 141.051L220.204 118.929L220.262 118.888C220.17 118.83 220.096 118.755 220.038 118.664L217.505 114.769L217.488 114.777Z"
        fill="#EDEFF1"
      />
      <path
        d="M245.224 121.022L246.179 120.399C246.494 120.192 246.918 120.283 247.125 120.598L250.671 126.054L248.57 127.424L245.024 121.969C244.817 121.653 244.908 121.23 245.224 121.022Z"
        fill="#A4C9EB"
      />
      <path
        d="M240.2 122.052L241.155 121.429C241.47 121.221 241.894 121.313 242.101 121.628L246.677 128.653L244.576 130.024L240.001 122.998C239.793 122.683 239.884 122.259 240.2 122.052Z"
        fill="#6EACE5"
      />
      <path
        d="M235.109 122.974L236.064 122.351C236.38 122.143 236.804 122.234 237.011 122.55L242.683 131.261L240.582 132.631L234.91 123.92C234.703 123.605 234.794 123.181 235.109 122.974Z"
        fill="#228BE6"
      />
      <path
        d="M230.086 124.003L231.041 123.38C231.356 123.173 231.78 123.264 231.987 123.58L238.689 133.868L236.588 135.239L229.886 124.95C229.679 124.634 229.77 124.211 230.086 124.003Z"
        fill="#A4C9EB"
      />
      <path
        d="M223.999 115.907L230.011 111.987C230.094 111.937 230.111 111.829 230.061 111.746C230.011 111.663 229.903 111.647 229.82 111.696L223.808 115.616C223.725 115.666 223.708 115.774 223.758 115.857C223.808 115.94 223.916 115.956 223.999 115.907Z"
        fill="#E0E0E0"
      />
      <path
        d="M225.386 118.032L231.398 114.113C231.481 114.063 231.497 113.955 231.447 113.872C231.398 113.789 231.29 113.772 231.207 113.822L225.195 117.742C225.112 117.792 225.095 117.9 225.145 117.983C225.195 118.066 225.303 118.082 225.386 118.032Z"
        fill="#E0E0E0"
      />
      <path
        d="M226.764 120.166L232.776 116.247C232.859 116.197 232.876 116.089 232.826 116.006C232.776 115.923 232.668 115.906 232.585 115.956L226.573 119.876C226.49 119.926 226.474 120.034 226.523 120.117C226.573 120.2 226.681 120.216 226.764 120.166Z"
        fill="#E0E0E0"
      />
      <path
        d="M235.607 136.069L251.825 125.514C251.908 125.465 251.925 125.357 251.875 125.274C251.825 125.191 251.717 125.174 251.634 125.224L235.416 135.778C235.333 135.828 235.317 135.936 235.367 136.019C235.416 136.102 235.524 136.119 235.607 136.069Z"
        fill="#E0E0E0"
      />
      <path
        d="M237.044 113.773L242.243 110.393C242.326 110.343 242.342 110.235 242.293 110.152L239.336 105.61C239.287 105.527 239.179 105.51 239.096 105.56C239.013 105.61 238.996 105.718 239.046 105.801L241.911 110.202L236.862 113.49C236.779 113.54 236.762 113.648 236.812 113.731C236.862 113.814 236.97 113.831 237.053 113.781L237.044 113.773Z"
        fill="#E0E0E0"
      />
      <path
        d="M242.242 110.393C242.242 110.393 242.309 110.326 242.317 110.285C242.334 110.193 242.276 110.102 242.184 110.085L238.365 109.313C238.281 109.297 238.198 109.338 238.174 109.421L237.567 110.982L235.209 110.318C235.118 110.293 235.026 110.343 235.001 110.434C234.976 110.526 235.026 110.617 235.118 110.642L237.625 111.348C237.708 111.373 237.8 111.331 237.833 111.248L238.448 109.679L242.126 110.418C242.176 110.426 242.218 110.418 242.251 110.393H242.242Z"
        fill="#6EACE5"
      />
      <path
        d="M235.342 111.339C235.417 111.29 235.442 111.198 235.4 111.115L235.06 110.467L235.708 110.127C235.799 110.077 235.824 109.977 235.782 109.894C235.741 109.811 235.633 109.778 235.55 109.82L234.753 110.243C234.67 110.285 234.637 110.393 234.678 110.476L235.102 111.273C235.143 111.356 235.251 111.389 235.334 111.348H235.351L235.342 111.339Z"
        fill="#6EACE5"
      />
      <path
        d="M257.406 112.336L251.875 134.69L246.146 133.943L244.136 110.476H244.194C243.912 107.802 245.224 105.103 247.74 103.733C251.078 101.914 255.255 103.143 257.074 106.482C258.095 108.367 258.153 110.501 257.406 112.336Z"
        fill="#77463F"
      />
      <path
        d="M257.813 108.765L244.203 110.791L239.005 74.9843C238.274 72.2356 239.329 69.2047 241.845 67.5605C244.975 65.5094 249.185 66.3813 251.237 69.5202C251.809 70.3838 252.142 71.3305 252.266 72.2938L252.299 72.5512L257.805 108.765H257.813Z"
        fill="#77463F"
      />
      <path
        d="M242.733 123.247L238.556 74.8679C237.676 72.0528 238.664 68.8807 241.189 67.0787C244.103 65.0027 248.048 65.4594 250.423 68.0171C250.788 68.4406 251.129 68.8973 251.419 69.3956C251.809 70.0765 252.059 70.7989 252.183 71.538C252.216 71.6376 252.225 71.7539 252.241 71.8619L260.628 121.528C260.877 122.525 260.163 123.505 259.142 123.579L244.51 124.684C243.63 124.75 242.849 124.119 242.741 123.239L242.733 123.247Z"
        fill="#6EACE5"
      />
      <path
        d="M252.026 131.427L251.976 134.283V134.3L251.943 135.928H251.959L251.926 137.04L251.81 141.126H243.356L245.524 136.816L246.03 135.811H246.055L246.097 133.395V133.37L246.138 131.311C246.138 131.252 246.147 131.194 246.147 131.144C246.255 130.306 246.969 129.666 247.832 129.683L250.398 129.733C251.312 129.749 252.042 130.505 252.026 131.427Z"
        fill="#77463F"
      />
      <path
        d="M170.687 91.2352C170.687 91.2352 176.251 91.3017 177.679 94.316C179.108 97.3304 177.364 98.1276 179.739 99.8714C182.114 101.615 179.739 104.497 179.739 104.497L170.687 91.2352Z"
        fill="#B76B5C"
      />
      <path
        d="M168.952 81.5279C168.952 81.5279 167.922 82.2669 168.952 83.2966C169.982 84.3263 171.153 83.5623 171.643 84.5921C172.132 85.6218 173.644 84.8578 173.644 84.8578C173.644 84.8578 169.4 81.8517 168.952 81.5279Z"
        fill="#B76B5C"
      />
      <path
        d="M155.458 83.9607C155.458 83.9607 156.421 83.5704 157.426 84.7247C158.431 85.879 158.887 86.0368 159.734 86.5682C160.581 87.0997 159.934 88.0048 159.934 88.0048L155.45 83.9607"
        fill="#B76B5C"
      />
      <path
        d="M223.692 60.7344C223.692 60.7344 222.073 56.981 225.088 56.1091C228.102 55.2371 228.808 53.6511 229.098 53.2608C229.389 52.8705 230.203 53.2608 230.203 53.2608C230.203 53.2608 227.487 59.1234 223.701 60.7344H223.692Z"
        fill="#B76B5C"
      />
      <path
        d="M211.967 48.295C211.967 48.295 213.511 49.6984 214.043 51.4257C214.649 53.3688 212.913 52.8789 214.043 54.4816C215.172 56.0842 213.819 58.1769 213.819 58.1769C213.819 58.1769 211.751 53.8172 211.958 48.295"
        fill="#B76B5C"
      />
      <path
        d="M233.35 47.3898C233.35 47.3898 232.511 47.8466 232.694 48.7019C232.876 49.5572 232.17 49.4492 232.27 50.0056C232.37 50.562 232.893 50.9107 232.893 50.9107C232.893 50.9107 234.006 48.9759 233.35 47.3898Z"
        fill="#B76B5C"
      />
      <path
        d="M224.007 68.7479C224.007 68.7479 224.481 66.6636 226.133 66.4477C227.786 66.2318 228.209 66.5723 228.89 65.7668C229.571 64.9613 230.36 65.3848 230.36 65.3848C230.36 65.3848 228.591 67.3279 226.474 68.1916C225.079 68.7562 224.007 68.7562 224.007 68.7562V68.7479Z"
        fill="#B76B5C"
      />
      <path
        d="M254.351 124.692C254.351 124.692 250.465 126.694 251.029 128.487C251.594 130.281 249.767 131.369 250.407 132.49C251.046 133.611 252.15 133.603 252.15 133.603"
        fill="#B76B5C"
      />
      <path
        d="M123.604 73.4894C138.789 73.4894 151.098 61.1796 151.098 45.9947C151.098 30.8098 138.789 18.5 123.604 18.5C108.419 18.5 96.109 30.8098 96.109 45.9947C96.109 61.1796 108.419 73.4894 123.604 73.4894Z"
        fill="#EDEFF1"
      />
      <path
        d="M134.574 28.9465H112.634C112.368 28.9465 112.153 29.1621 112.153 29.4281V43.9187C112.153 44.1847 112.368 44.4003 112.634 44.4003H134.574C134.84 44.4003 135.055 44.1847 135.055 43.9187V29.4281C135.055 29.1621 134.84 28.9465 134.574 28.9465Z"
        fill="#A6CBED"
      />
      <path
        d="M118.854 36.8766H117.467C117.146 36.8766 116.886 37.1369 116.886 37.4579V41.0037C116.886 41.3248 117.146 41.585 117.467 41.585H118.854C119.175 41.585 119.435 41.3248 119.435 41.0037V37.4579C119.435 37.1369 119.175 36.8766 118.854 36.8766Z"
        fill="#EDEFF1"
      />
      <path
        d="M122.417 34.3274H121.03C120.709 34.3274 120.448 34.5877 120.448 34.9087V41.0039C120.448 41.3249 120.709 41.5852 121.03 41.5852H122.417C122.738 41.5852 122.998 41.3249 122.998 41.0039V34.9087C122.998 34.5877 122.738 34.3274 122.417 34.3274Z"
        fill="#228BE6"
      />
      <path
        d="M125.979 31.7614H124.592C124.271 31.7614 124.011 32.0216 124.011 32.3427V41.0121C124.011 41.3331 124.271 41.5934 124.592 41.5934H125.979C126.3 41.5934 126.56 41.3331 126.56 41.0121V32.3427C126.56 32.0216 126.3 31.7614 125.979 31.7614Z"
        fill="#EDEFF1"
      />
      <path
        d="M129.749 35.9384H128.362C128.041 35.9384 127.781 36.1986 127.781 36.5196V41.0038C127.781 41.3249 128.041 41.5851 128.362 41.5851H129.749C130.07 41.5851 130.33 41.3249 130.33 41.0038V36.5196C130.33 36.1986 130.07 35.9384 129.749 35.9384Z"
        fill="#228BE6"
      />
      <path
        d="M134.574 46.7834H112.634C112.368 46.7834 112.153 46.9991 112.153 47.2651V61.7556C112.153 62.0216 112.368 62.2373 112.634 62.2373H134.574C134.84 62.2373 135.055 62.0216 135.055 61.7556V47.2651C135.055 46.9991 134.84 46.7834 134.574 46.7834Z"
        fill="#A6CBED"
      />
      <path
        d="M124.783 56.6901L121.678 53.2356C121.536 53.0779 121.287 53.0695 121.138 53.2107L117.409 56.7565L116.977 56.2998L121.179 52.3056C121.337 52.1561 121.578 52.1644 121.719 52.3305L124.833 55.8016C124.974 55.9594 125.215 55.9677 125.365 55.8265L129.708 51.907L130.131 52.372L125.315 56.715C125.157 56.8562 124.916 56.8396 124.783 56.6901Z"
        fill="#6EACE5"
      />
      <path
        d="M121.445 53.4848C121.995 53.4848 122.441 53.0386 122.441 52.4883C122.441 51.9379 121.995 51.4918 121.445 51.4918C120.894 51.4918 120.448 51.9379 120.448 52.4883C120.448 53.0386 120.894 53.4848 121.445 53.4848Z"
        fill="#228BE6"
      />
      <path
        d="M117.293 57.5206C117.843 57.5206 118.289 57.0745 118.289 56.5241C118.289 55.9738 117.843 55.5276 117.293 55.5276C116.742 55.5276 116.296 55.9738 116.296 56.5241C116.296 57.0745 116.742 57.5206 117.293 57.5206Z"
        fill="#228BE6"
      />
      <path
        d="M129.923 53.4848C130.473 53.4848 130.92 53.0386 130.92 52.4883C130.92 51.9379 130.473 51.4918 129.923 51.4918C129.373 51.4918 128.927 51.9379 128.927 52.4883C128.927 53.0386 129.373 53.4848 129.923 53.4848Z"
        fill="#228BE6"
      />
      <path
        d="M125.289 57.5206C125.84 57.5206 126.286 57.0745 126.286 56.5241C126.286 55.9738 125.84 55.5276 125.289 55.5276C124.739 55.5276 124.293 55.9738 124.293 56.5241C124.293 57.0745 124.739 57.5206 125.289 57.5206Z"
        fill="#228BE6"
      />
    </svg>
  ) : (
    <svg
      width="416"
      height="224"
      viewBox="0 0 416 224"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="416" height="224" fill="white" />
      <path
        d="M365.215 26H260.986C259.825 26 258.885 26.9405 258.885 28.1007V102.711C258.885 103.871 259.825 104.811 260.986 104.811H365.215C366.375 104.811 367.316 103.871 367.316 102.711V28.1007C367.316 26.9405 366.375 26 365.215 26Z"
        fill="#E0E0E0"
      />
      <path
        d="M361.691 30.0495H265.923C264.763 30.0495 263.822 30.99 263.822 32.1502V98.6607C263.822 99.8209 264.763 100.761 265.923 100.761H361.691C362.851 100.761 363.792 99.8209 363.792 98.6607V32.1502C363.792 30.99 362.851 30.0495 361.691 30.0495Z"
        fill="#EDEFF1"
      />
      <path
        d="M351.339 50.8348L349.355 46.0382C349.285 45.8748 349.157 45.7464 348.993 45.6764L344.197 43.6808C344.033 43.6107 343.847 43.6107 343.683 43.6808L338.887 45.6764C338.723 45.7464 338.595 45.8748 338.525 46.0382L336.541 50.8348C336.471 50.9982 336.471 51.1849 336.541 51.3483L338.525 56.1449C338.595 56.3083 338.723 56.4367 338.887 56.5067L343.683 58.4907C343.847 58.5607 344.033 58.5607 344.197 58.4907L348.993 56.5067C349.157 56.4367 349.285 56.3083 349.355 56.1449L351.339 51.3483C351.409 51.1849 351.409 50.9982 351.339 50.8348ZM350.616 51.3483L348.842 55.6431C348.772 55.8064 348.643 55.9348 348.48 56.0048L344.197 57.7788C344.033 57.8488 343.847 57.8488 343.683 57.7788L339.4 56.0048C339.237 55.9348 339.108 55.8064 339.038 55.6431L337.264 51.3483C337.194 51.1849 337.194 50.9982 337.264 50.8348L339.038 46.5517C339.108 46.3883 339.237 46.2599 339.4 46.1899L343.683 44.416C343.847 44.346 344.033 44.346 344.197 44.416L348.48 46.1899C348.643 46.2599 348.772 46.3883 348.842 46.5517L350.616 50.8348C350.686 50.9982 350.686 51.1849 350.616 51.3483Z"
        fill="#E0E0E0"
      />
      <path
        d="M348.702 50.8348L347.488 47.8938C347.418 47.7304 347.29 47.6021 347.126 47.532L344.185 46.3183C344.022 46.2483 343.835 46.2483 343.672 46.3183L340.731 47.532C340.567 47.6021 340.439 47.7304 340.369 47.8938L339.155 50.8348C339.085 50.9982 339.085 51.1849 339.155 51.3483L340.369 54.2893C340.439 54.4527 340.567 54.581 340.731 54.6511L343.672 55.8648C343.835 55.9348 344.022 55.9348 344.185 55.8648L347.126 54.6511C347.29 54.581 347.418 54.4527 347.488 54.2893L348.702 51.3483C348.772 51.1849 348.772 50.9982 348.702 50.8348ZM347.978 51.3483L346.975 53.7758C346.905 53.9392 346.776 54.0675 346.613 54.1376L344.185 55.1412C344.022 55.2113 343.835 55.2113 343.672 55.1412L341.244 54.1376C341.081 54.0675 340.953 53.9392 340.883 53.7758L339.879 51.3483C339.809 51.1849 339.809 50.9982 339.879 50.8348L340.883 48.4073C340.953 48.2439 341.081 48.1156 341.244 48.0455L343.672 47.0419C343.835 46.9718 344.022 46.9718 344.185 47.0419L346.613 48.0455C346.776 48.1156 346.905 48.2439 346.975 48.4073L347.978 50.8348C348.048 50.9982 348.048 51.1849 347.978 51.3483Z"
        fill="#E0E0E0"
      />
      <path
        d="M346.333 50.8348L345.807 49.5744C345.737 49.411 345.609 49.2827 345.446 49.2126L344.197 48.6875C344.033 48.6174 343.847 48.6174 343.683 48.6875L342.435 49.2126C342.271 49.2827 342.143 49.411 342.073 49.5744L341.548 50.8348C341.478 50.9982 341.478 51.185 341.548 51.3483L342.073 52.6088C342.143 52.7722 342.271 52.9005 342.435 52.9706L343.683 53.4957C343.847 53.5658 344.033 53.5658 344.197 53.4957L345.446 52.9706C345.609 52.9005 345.737 52.7722 345.807 52.6088L346.333 51.3483C346.403 51.185 346.403 50.9982 346.333 50.8348ZM345.609 51.3483L345.305 52.0953C345.235 52.2587 345.107 52.387 344.944 52.4571L344.208 52.7605C344.045 52.8305 343.858 52.8305 343.695 52.7605L342.96 52.4571C342.796 52.387 342.668 52.2587 342.598 52.0953L342.295 51.3483C342.224 51.185 342.224 50.9982 342.295 50.8348L342.598 50.0879C342.668 49.9245 342.796 49.7962 342.96 49.7261L343.695 49.4227C343.858 49.3527 344.045 49.3527 344.208 49.4227L344.944 49.7261C345.107 49.7962 345.235 49.9245 345.305 50.0879L345.609 50.8348C345.679 50.9982 345.679 51.185 345.609 51.3483Z"
        fill="#E0E0E0"
      />
      <path
        d="M350.394 44.8946C350.394 44.8946 351.911 41.6735 355.412 42.012"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M354.863 40.7399L356.089 42.1171L354.735 43.3191"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M360.675 39.7595L358.131 42.292"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M358.446 40.4248C358.691 40.4248 358.889 40.2262 358.889 39.9813C358.889 39.7364 358.691 39.5378 358.446 39.5378C358.201 39.5378 358.002 39.7364 358.002 39.9813C358.002 40.2262 358.201 40.4248 358.446 40.4248Z"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M360.442 42.4671C360.687 42.4671 360.885 42.2686 360.885 42.0236C360.885 41.7787 360.687 41.5802 360.442 41.5802C360.197 41.5802 359.998 41.7787 359.998 42.0236C359.998 42.2686 360.197 42.4671 360.442 42.4671Z"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M272.96 85.1229C272.96 85.1229 275.189 80.9682 277.126 80.9682C279.064 80.9682 280.231 85.7298 283.487 85.7298C286.743 85.7298 289.03 80.9682 289.03 80.9682"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M277.254 81.8202C277.731 81.8202 278.118 81.4335 278.118 80.9565C278.118 80.4796 277.731 80.0929 277.254 80.0929C276.777 80.0929 276.39 80.4796 276.39 80.9565C276.39 81.4335 276.777 81.8202 277.254 81.8202Z"
        fill="#E0E0E0"
      />
      <path
        d="M283.394 86.5815C283.87 86.5815 284.257 86.1949 284.257 85.7179C284.257 85.241 283.87 84.8543 283.394 84.8543C282.917 84.8543 282.53 85.241 282.53 85.7179C282.53 86.1949 282.917 86.5815 283.394 86.5815Z"
        fill="#E0E0E0"
      />
      <path
        d="M289.029 81.6683C289.506 81.6683 289.893 81.2816 289.893 80.8047C289.893 80.3277 289.506 79.941 289.029 79.941C288.552 79.941 288.166 80.3277 288.166 80.8047C288.166 81.2816 288.552 81.6683 289.029 81.6683Z"
        fill="#E0E0E0"
      />
      <path
        d="M272.96 86.3131C273.437 86.3131 273.823 85.9265 273.823 85.4495C273.823 84.9726 273.437 84.5859 272.96 84.5859C272.483 84.5859 272.096 84.9726 272.096 85.4495C272.096 85.9265 272.483 86.3131 272.96 86.3131Z"
        fill="#E0E0E0"
      />
      <path
        d="M289.893 75.2145L290.687 76.58L293.535 72.9854"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M341.921 79.7779H339.948C339.491 79.7779 339.12 80.1489 339.12 80.6065V85.6482C339.12 86.1058 339.491 86.4768 339.948 86.4768H341.921C342.378 86.4768 342.749 86.1058 342.749 85.6482V80.6065C342.749 80.1489 342.378 79.7779 341.921 79.7779Z"
        fill="#E0E0E0"
      />
      <path
        d="M346.985 76.1599H345.013C344.555 76.1599 344.184 76.5309 344.184 76.9886V85.6481C344.184 86.1057 344.555 86.4767 345.013 86.4767H346.985C347.443 86.4767 347.814 86.1057 347.814 85.6481V76.9886C347.814 76.5309 347.443 76.1599 346.985 76.1599Z"
        fill="#E0E0E0"
      />
      <path
        d="M352.05 72.5072H350.078C349.62 72.5072 349.249 72.8782 349.249 73.3358V85.6482C349.249 86.1059 349.62 86.4768 350.078 86.4768H352.05C352.508 86.4768 352.879 86.1059 352.879 85.6482V73.3358C352.879 72.8782 352.508 72.5072 352.05 72.5072Z"
        fill="#E0E0E0"
      />
      <path
        d="M357.407 78.4476H355.435C354.977 78.4476 354.606 78.8186 354.606 79.2762V85.6483C354.606 86.106 354.977 86.4769 355.435 86.4769H357.407C357.864 86.4769 358.235 86.106 358.235 85.6483V79.2762C358.235 78.8186 357.864 78.4476 357.407 78.4476Z"
        fill="#E0E0E0"
      />
      <path
        d="M286.837 50.4263H274.933C274.746 50.4263 274.606 50.2746 274.606 50.0995V39.6894C274.606 39.5027 274.758 39.3626 274.933 39.3626C275.108 39.3626 275.259 39.5143 275.259 39.6894V49.7611H286.837C287.023 49.7611 287.163 49.9128 287.163 50.0878C287.163 50.2629 287.012 50.4146 286.837 50.4146V50.4263Z"
        fill="#E0E0E0"
      />
      <path
        d="M274.932 50.4265C274.85 50.4265 274.757 50.3914 274.699 50.3331C274.57 50.2047 274.57 49.9946 274.699 49.8663L280.032 44.6262C280.149 44.5095 280.324 44.4978 280.452 44.5912L283.067 46.4585L286.171 42.9223C286.288 42.7822 286.498 42.7706 286.638 42.8873C286.778 43.004 286.789 43.2141 286.673 43.3541L283.37 47.1237C283.253 47.2521 283.067 47.2754 282.926 47.1704L280.301 45.2797L275.166 50.3214C275.096 50.3798 275.014 50.4148 274.932 50.4148V50.4265Z"
        fill="#E0E0E0"
      />
      <path
        d="M287.023 44.7195C286.86 44.7195 286.708 44.5911 286.696 44.416L286.568 43.0156L285.168 43.144C284.969 43.1556 284.829 43.0272 284.806 42.8522C284.794 42.6655 284.923 42.5137 285.098 42.4904L286.825 42.327C287 42.3037 287.163 42.4437 287.187 42.6188L287.35 44.346C287.362 44.5327 287.233 44.6845 287.058 44.7078H287.023V44.7195Z"
        fill="#E0E0E0"
      />
      <path
        d="M312.325 78.3189L312.173 80.1512L310.376 79.9995"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M314.157 82.0067H326.621"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M314.157 84.1776H324.018"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M314.157 86.465H319.432"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M313.236 56.53C313.749 56.53 314.158 56.1215 314.158 55.608C314.158 55.0945 313.749 54.686 313.236 54.686C312.722 54.686 312.314 55.0945 312.314 55.608C312.314 56.1215 312.722 56.53 313.236 56.53Z"
        fill="#E0E0E0"
      />
      <path
        d="M314.892 57.9888C314.636 57.312 313.994 56.8335 313.223 56.8335C312.453 56.8335 311.811 57.312 311.555 57.9888C311.438 58.2923 311.683 58.6074 312.01 58.6074H314.437C314.752 58.6074 314.997 58.2923 314.892 57.9888Z"
        fill="#E0E0E0"
      />
      <path
        d="M318.498 56.53C319.011 56.53 319.42 56.1215 319.42 55.608C319.42 55.0945 319.011 54.686 318.498 54.686C317.984 54.686 317.576 55.0945 317.576 55.608C317.576 56.1215 317.984 56.53 318.498 56.53Z"
        fill="#E0E0E0"
      />
      <path
        d="M320.167 57.9888C319.91 57.312 319.268 56.8335 318.498 56.8335C317.728 56.8335 317.086 57.312 316.829 57.9888C316.713 58.2923 316.958 58.6074 317.284 58.6074H319.712C320.027 58.6074 320.272 58.2923 320.167 57.9888Z"
        fill="#E0E0E0"
      />
      <path
        d="M302.685 56.53C303.199 56.53 303.607 56.1215 303.607 55.608C303.607 55.0945 303.199 54.686 302.685 54.686C302.172 54.686 301.763 55.0945 301.763 55.608C301.763 56.1215 302.172 56.53 302.685 56.53Z"
        fill="#E0E0E0"
      />
      <path
        d="M304.342 57.9888C304.085 57.312 303.443 56.8335 302.673 56.8335C301.903 56.8335 301.261 57.312 301.004 57.9888C300.887 58.2923 301.132 58.6074 301.459 58.6074H303.887C304.202 58.6074 304.447 58.2923 304.342 57.9888Z"
        fill="#E0E0E0"
      />
      <path
        d="M307.96 56.53C308.473 56.53 308.882 56.1215 308.882 55.608C308.882 55.0945 308.473 54.686 307.96 54.686C307.446 54.686 307.038 55.0945 307.038 55.608C307.038 56.1215 307.446 56.53 307.96 56.53Z"
        fill="#E0E0E0"
      />
      <path
        d="M309.616 57.9888C309.36 57.312 308.718 56.8335 307.947 56.8335C307.177 56.8335 306.535 57.312 306.279 57.9888C306.162 58.2923 306.407 58.6074 306.734 58.6074H309.161C309.476 58.6074 309.721 58.2923 309.616 57.9888Z"
        fill="#E0E0E0"
      />
      <path
        d="M313.236 62.9488C313.749 62.9488 314.158 62.5404 314.158 62.0269C314.158 61.5134 313.749 61.1049 313.236 61.1049C312.722 61.1049 312.314 61.5134 312.314 62.0269C312.314 62.5404 312.722 62.9488 313.236 62.9488Z"
        fill="#E0E0E0"
      />
      <path
        d="M314.892 64.4195C314.636 63.7426 313.994 63.2641 313.223 63.2641C312.453 63.2641 311.811 63.7426 311.555 64.4195C311.438 64.7229 311.683 65.038 312.01 65.038H314.437C314.752 65.038 314.997 64.7229 314.892 64.4195Z"
        fill="#E0E0E0"
      />
      <path
        d="M318.498 62.9488C319.011 62.9488 319.42 62.5404 319.42 62.0269C319.42 61.5134 319.011 61.1049 318.498 61.1049C317.984 61.1049 317.576 61.5134 317.576 62.0269C317.576 62.5404 317.984 62.9488 318.498 62.9488Z"
        fill="#E0E0E0"
      />
      <path
        d="M320.167 64.4195C319.91 63.7426 319.268 63.2641 318.498 63.2641C317.728 63.2641 317.086 63.7426 316.829 64.4195C316.713 64.7229 316.958 65.038 317.284 65.038H319.712C320.027 65.038 320.272 64.7229 320.167 64.4195Z"
        fill="#E0E0E0"
      />
      <path
        d="M302.685 62.9488C303.199 62.9488 303.607 62.5404 303.607 62.0269C303.607 61.5134 303.199 61.1049 302.685 61.1049C302.172 61.1049 301.763 61.5134 301.763 62.0269C301.763 62.5404 302.172 62.9488 302.685 62.9488Z"
        fill="#E0E0E0"
      />
      <path
        d="M304.342 64.4195C304.085 63.7426 303.443 63.2641 302.673 63.2641C301.903 63.2641 301.261 63.7426 301.004 64.4195C300.887 64.7229 301.132 65.038 301.459 65.038H303.887C304.202 65.038 304.447 64.7229 304.342 64.4195Z"
        fill="#E0E0E0"
      />
      <path
        d="M307.96 62.9488C308.473 62.9488 308.882 62.5404 308.882 62.0269C308.882 61.5134 308.473 61.1049 307.96 61.1049C307.446 61.1049 307.038 61.5134 307.038 62.0269C307.038 62.5404 307.446 62.9488 307.96 62.9488Z"
        fill="#E0E0E0"
      />
      <path
        d="M309.616 64.4195C309.36 63.7426 308.718 63.2641 307.947 63.2641C307.177 63.2641 306.535 63.7426 306.279 64.4195C306.162 64.7229 306.407 65.038 306.734 65.038H309.161C309.476 65.038 309.721 64.7229 309.616 64.4195Z"
        fill="#E0E0E0"
      />
      <path
        d="M308.882 68.6791C308.882 68.6791 305.824 75.553 311.858 79.6844"
        stroke="#E0E0E0"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M279.484 98.859H268.665C268.472 98.859 268.315 99.0158 268.315 99.2092V100.575C268.315 100.768 268.472 100.925 268.665 100.925H279.484C279.677 100.925 279.834 100.768 279.834 100.575V99.2092C279.834 99.0158 279.677 98.859 279.484 98.859Z"
        fill="#E0E0E0"
      />
      <path
        d="M33.4798 197.312H28.9983C27.5044 197.312 26.209 196.297 25.8589 194.838L8.09632 121.22C7.87458 120.333 8.03796 119.388 8.56314 118.629L12.5661 111.744C12.3211 112.211 12.251 112.771 12.3911 113.331L33.4798 197.312Z"
        fill="#6FAAE3"
      />
      <path
        d="M97.7842 197.312H33.4795L12.3908 113.331C12.2508 112.771 12.3208 112.21 12.5659 111.744C12.5659 111.72 12.5776 111.685 12.6009 111.662L12.7293 111.452C13.1378 110.833 13.838 110.425 14.6549 110.425H78.2944C79.3564 110.425 80.2901 111.148 80.5585 112.187L100.924 193.297C101.437 195.34 99.8966 197.312 97.7842 197.312Z"
        fill="#A4C9EB"
      />
      <path
        d="M85.1694 88.2273C85.1694 88.2273 89.5226 91.0749 88.6589 95.9065C87.7953 100.738 88.1454 99.6177 89.3475 102.384C90.5496 105.15 91.5882 107.169 89.7793 110.903C87.9704 114.638 94.3658 114.509 92.1134 121.01C89.861 127.51 93.2338 125.771 94.1908 130.171C95.1478 134.571 92.2885 139.064 88.0637 137.675C83.839 136.287 80.0461 140.009 75.3428 139.146C70.6396 138.282 63.2522 137.115 65.2128 128.467C67.1735 119.819 69.3325 118.361 68.5623 112.7C67.792 107.04 61.1865 102.127 65.6913 94.7044C70.1961 87.282 69.7643 80.5597 69.7643 80.5597C69.7643 80.5597 81.9134 79.2526 85.1811 88.2273H85.1694Z"
        fill="#D34F16"
      />
      <path
        d="M84.8539 91.6237C84.8539 91.6237 84.6672 92.5573 85.8576 94.3429C87.048 96.1285 87.0713 98.7544 86.3244 100.482C84.6089 104.403 87.9116 105.383 87.6432 108.231C87.3748 111.078 84.3754 112.351 86.6745 115.373C88.3901 117.626 87.9816 118.489 86.7912 121.535C85.6008 124.581 85.4024 125.713 88.997 130.113C91.6695 133.381 68.6786 133.813 71.2811 123.753C73.8836 113.693 72.063 104.169 73.6385 101.497C75.2141 98.8244 74.9223 86.2435 84.8539 91.6353V91.6237Z"
        fill="#A53007"
      />
      <path
        d="M94.903 187.485C95.0897 192.819 99.5596 196.985 104.905 196.799C106.632 196.74 108.231 196.227 109.608 195.386C110.822 194.64 112.024 193.869 113.284 193.216L142.11 180.051L140.173 172.372L104.636 177.472L102.162 177.776C97.8557 178.873 94.7396 182.852 94.9147 187.485H94.903Z"
        fill="#E0E0E0"
      />
      <path
        d="M78.4944 141.69L95.4867 190.193L113.716 183.739L96.5721 135.773C95.6384 131.91 92.359 128.911 88.181 128.514C82.9409 128.024 78.296 131.887 77.8058 137.127C77.6541 138.738 77.9109 140.29 78.4944 141.69Z"
        fill="#E0E0E0"
      />
      <path
        d="M98.1243 196.04H45.6185L29.8283 142.472C27.6926 135.283 31.5672 127.662 38.5695 125.316C43.4478 123.683 50.5201 122.516 60.7552 122.516C75.6818 122.516 84.5748 124.885 89.8499 127.534C94.6231 129.938 97.4007 135.12 96.7822 140.5L98.1243 196.04Z"
        fill="#E6A898"
      />
      <path
        d="M29.8283 142.472L33.8196 156.022L45.6185 196.04H98.1243L96.7822 140.5C97.4007 135.12 94.6231 129.938 89.8499 127.534C84.5748 124.885 75.6818 122.516 60.7552 122.516C54.1147 122.516 48.8162 123.006 44.5682 123.799C42.2691 124.231 40.2851 124.745 38.5695 125.316C31.5672 127.662 27.6926 135.283 29.8283 142.472Z"
        fill="#EDEFF1"
      />
      <path
        d="M29.8287 141.258L29.9687 141.655L46.9727 190.205L65.2021 183.751L48.0581 135.785C47.1361 131.922 43.8333 128.911 39.6669 128.526C34.4269 128.036 29.7703 131.899 29.2918 137.139C29.1518 138.574 29.3618 139.975 29.8287 141.258Z"
        fill="#E0E0E0"
      />
      <path
        d="M46.2614 187.602C46.4481 192.936 50.9179 197.102 56.263 196.915C57.9903 196.857 59.5891 196.344 60.9662 195.503C62.18 194.756 63.382 193.986 64.6425 193.333L93.4687 180.168L91.5314 172.489L55.9946 177.589L53.5204 177.892C49.214 178.99 46.098 182.969 46.273 187.602H46.2614Z"
        fill="#E0E0E0"
      />
      <path
        d="M87.5165 178.266C87.8666 179.269 88.5669 180.051 89.4305 180.518C89.5122 180.577 89.6056 180.623 89.6989 180.658C89.8856 180.74 90.0957 180.787 90.3175 180.787L90.7493 180.717L101.731 178.931C101.731 178.931 101.801 178.943 101.836 178.954L109.492 180.74C109.492 180.74 109.586 180.763 109.644 180.775C109.761 180.798 109.889 180.798 110.017 180.763C110.099 180.74 110.169 180.717 110.239 180.682C110.613 180.483 110.811 180.051 110.718 179.62C110.648 179.351 110.472 179.141 110.239 179.024L109.761 178.721H111.78C111.85 178.709 111.931 178.686 112.001 178.674C113.005 178.429 113.624 177.414 113.378 176.422C113.332 176.212 113.238 176.013 113.122 175.838L109.084 170.085C108.897 169.793 108.629 169.56 108.313 169.419C108.068 169.303 107.812 169.244 107.532 169.244H96.1994C96.036 169.244 95.8726 169.268 95.7092 169.303C95.4758 169.361 95.2541 169.454 95.0557 169.583C95.0557 169.583 95.044 169.583 95.0324 169.606L90.8193 172.36L89.4422 173.259L88.8936 173.609L88.8586 173.644C87.5049 174.706 86.9097 176.55 87.5165 178.266Z"
        fill="#D28070"
      />
      <path
        d="M87.5165 178.277C87.8666 179.281 88.5669 180.063 89.4305 180.53C89.5122 180.588 89.6056 180.635 89.6989 180.67C89.8856 180.752 90.0957 180.798 90.3175 180.798C90.7493 180.798 91.1461 180.623 91.4378 180.331L97.2731 174.414C97.7049 173.901 98.4635 173.866 98.942 174.286C99.0237 174.344 99.0937 174.414 99.1521 174.508L99.9457 175.675L101.463 177.892C101.778 178.371 102.291 178.686 102.863 178.733H111.78C111.85 178.721 111.931 178.698 112.001 178.686C113.005 178.441 113.624 177.425 113.378 176.433C113.332 176.223 113.238 176.025 113.122 175.85L109.084 170.096C108.897 169.805 108.629 169.571 108.313 169.431C108.068 169.314 107.812 169.256 107.532 169.256H96.1994C96.036 169.256 95.8726 169.279 95.7092 169.314C95.4758 169.373 95.2541 169.466 95.0557 169.595C95.0557 169.606 95.044 169.606 95.0324 169.618L90.8193 172.372L89.4422 173.271L88.8936 173.621L88.8586 173.656C87.5049 174.718 86.9097 176.562 87.5165 178.277Z"
        fill="#E4A696"
      />
      <path
        d="M143.441 177.286L147.736 176.585L146.942 175.418C146.51 174.776 145.577 174.73 145.075 175.325L143.441 177.286Z"
        fill="#E6A898"
      />
      <path
        d="M135.319 179.176C135.762 180.448 136.778 181.37 137.968 181.755C137.98 181.755 137.991 181.755 138.003 181.767L138.482 181.872C138.482 181.872 138.552 181.884 138.587 181.895L146.242 183.681C146.242 183.681 146.336 183.704 146.394 183.716C146.511 183.739 146.639 183.739 146.768 183.704C146.849 183.681 146.919 183.658 146.989 183.623C147.363 183.424 147.561 182.992 147.468 182.561C147.398 182.292 147.223 182.082 146.989 181.965L143.208 179.631C143.138 179.585 143.068 179.538 143.01 179.456C142.578 179.059 142.531 178.359 142.94 177.881L143.336 177.402L143.453 177.274L145.075 175.313C145.507 174.8 146.266 174.765 146.744 175.185C146.826 175.243 146.896 175.313 146.954 175.407L147.748 176.574L149.265 178.791C149.58 179.27 150.094 179.585 150.666 179.631H159.582C159.652 179.62 159.734 179.596 159.804 179.585C160.807 179.34 161.426 178.324 161.181 177.332C161.134 177.122 161.041 176.924 160.924 176.749L156.886 170.995C156.699 170.703 156.431 170.47 156.116 170.33C155.871 170.213 155.614 170.155 155.334 170.155H144.002C143.838 170.155 143.675 170.178 143.512 170.213C143.278 170.272 143.056 170.365 142.858 170.493C142.858 170.505 142.846 170.505 142.835 170.517L138.622 173.271L137.244 174.17L136.696 174.52L136.661 174.555C135.307 175.617 134.712 177.461 135.319 179.176Z"
        fill="#D58270"
      />
      <path
        d="M58.993 102.874C59.1214 103.002 59.2031 103.177 59.2031 103.376C59.2031 103.749 58.8997 104.053 58.5262 104.053C58.1528 104.053 57.8377 103.749 57.8377 103.376C57.8377 103.002 58.1411 102.687 58.5262 102.687C58.6079 102.687 58.6779 102.699 58.748 102.722C59.5766 101.17 59.7866 99.9912 59.3432 99.1976C58.8297 98.2523 57.5576 98.2056 57.5459 98.2056V97.9139C57.6159 97.9139 59.0047 97.9722 59.5999 99.0576C60.0901 99.9446 59.88 101.217 58.993 102.874Z"
        fill="#EDEFF1"
      />
      <path
        d="M72.1568 103.212V127.697C72.1568 128.794 71.4916 129.786 70.4762 130.195C68.2238 131.093 63.8357 131.443 58.0354 125.165C57.3585 124.429 56.9734 123.461 56.9734 122.457V103.201H72.1568V103.212Z"
        fill="#E4A696"
      />
      <path
        d="M72.1573 106.667V125.013C72.1573 125.013 61.7471 125.818 59.1913 110.109V106.667H72.1573Z"
        fill="#D28070"
      />
      <path
        d="M54.9071 96.2915C54.9071 96.5132 54.9071 96.7233 54.9305 96.9334C54.9188 96.945 54.9188 96.9567 54.9305 96.9684C55.2339 99.4309 55.8291 101.041 55.8291 101.041C55.8291 101.041 55.9925 101.637 56.3193 102.605C56.331 102.64 56.3543 102.675 56.366 102.71C58.0465 107.612 63.8118 121.558 74.7938 121.01C84.6087 120.52 84.9705 104.694 84.4686 96.3848V96.2915C84.4103 95.5212 84.3636 94.821 84.3052 94.2025C84.3052 94.1441 84.2936 94.0974 84.2936 94.0391C84.2936 94.0157 84.2936 93.9924 84.2819 93.969C83.1732 86.92 77.0578 81.5166 69.6821 81.5166C66.5543 81.5166 63.6484 82.4852 61.2676 84.1541C57.428 86.8267 54.9071 91.2615 54.9071 96.2915Z"
        fill="#E4A696"
      />
      <path
        d="M76.9185 109.363H77.6071C78.0856 109.363 78.5291 109.129 78.8092 108.732C79.0776 108.336 79.1476 107.834 78.9726 107.39L77.2103 100.388C77.1753 100.236 77.0002 100.131 76.8602 100.178C76.7085 100.213 76.6034 100.376 76.6501 100.528L78.424 107.565C78.5407 107.869 78.5057 108.161 78.3307 108.406C78.1556 108.651 77.8989 108.779 77.6071 108.779H76.9185C76.7551 108.779 76.6268 108.907 76.6268 109.071C76.6268 109.234 76.7551 109.363 76.9185 109.363Z"
        fill="#D58270"
      />
      <path
        d="M72.9389 109.841C72.9389 109.841 72.8923 109.841 72.8689 109.841C72.7172 109.876 72.6238 110.039 72.6588 110.191C72.6705 110.25 73.0323 111.662 74.211 112.21C75.4248 112.77 76.7202 111.79 76.7785 111.755C76.9069 111.662 76.9303 111.475 76.8369 111.347C76.7435 111.218 76.5568 111.195 76.4284 111.288C76.4284 111.288 75.3547 112.093 74.4678 111.685C73.5458 111.253 73.2424 110.074 73.2307 110.063C73.1957 109.934 73.079 109.841 72.9506 109.841H72.9389Z"
        fill="#D58270"
      />
      <path
        d="M68.7369 98.9408C68.7369 98.9408 68.8537 98.9408 68.912 98.9175L73.2184 97.552C73.5219 97.4587 73.6969 97.1319 73.6036 96.8168C73.5102 96.5133 73.1834 96.3383 72.8683 96.4316L68.5619 97.7971C68.2585 97.8905 68.0834 98.2172 68.1768 98.5323C68.2585 98.7774 68.4802 98.9408 68.7369 98.9408Z"
        fill="#D34F16"
      />
      <path
        d="M84.422 98.9407C84.6671 98.9407 84.9005 98.7773 84.9822 98.5322C85.0755 98.2288 84.9122 97.902 84.5971 97.797L80.2906 96.4315C79.9755 96.3381 79.6604 96.5015 79.5554 96.8166C79.462 97.1201 79.6254 97.4468 79.9405 97.5519L84.2469 98.9173C84.3053 98.9407 84.3637 98.9407 84.422 98.9407Z"
        fill="#D34F16"
      />
      <path
        d="M71.2926 87.2001C71.2926 87.2001 68.8184 87.8537 67.9781 91.4132C67.2079 94.6576 62.9015 94.9494 62.9015 94.9494C62.9015 94.9494 60.2406 96.0114 59.6104 99.0574C58.9802 102.103 54.5337 97.937 55.1405 93.689C55.7474 89.4409 66.6244 80.6996 71.2926 87.2001Z"
        fill="#A53007"
      />
      <path
        d="M73.0554 87.0952C73.0554 87.0952 68.3638 86.6284 68.1654 90.5613C67.967 94.4943 65.6679 94.7511 62.902 94.9495C60.1361 95.1479 59.4942 96.4083 59.6109 99.0575C59.7976 103.387 55.4095 102.92 59.2024 107.682C62.4235 111.732 60.6379 114.988 60.6379 117.602C60.6379 121.056 62.1667 119.936 63.1821 123.857C63.7889 126.192 62.3418 128.316 60.8946 130.241C60.0427 131.373 59.5409 133.357 61.5132 136.625C64.6759 141.877 56.5765 143.546 53.2154 137.419C49.8543 131.292 49.5042 132.143 43.4005 129.658C35.8263 126.577 36.8883 119.329 41.1014 115.828C45.3145 112.327 40.3778 108.02 42.5485 104.741C44.7193 101.462 48.1154 101.065 48.2788 96.3849C48.4655 90.8297 46.038 87.0718 54.5225 84.2009C57.7086 83.1272 58.7122 77.2919 67.045 79.696"
        fill="#D34F16"
      />
      <path
        d="M58.6 107.585C60.2087 107.163 61.0003 104.866 60.3682 102.453C59.736 100.04 57.9195 98.4252 56.3109 98.8466C54.7022 99.268 53.9106 101.566 54.5427 103.979C55.1749 106.392 56.9914 108.006 58.6 107.585Z"
        fill="#E4A696"
      />
      <path
        d="M59.1911 103.924C59.1911 103.924 59.2261 103.924 59.2378 103.924C59.3895 103.901 59.4945 103.772 59.4829 103.621C59.4362 102.36 58.771 99.9795 56.6703 99.9795C56.5069 99.9795 56.3785 100.108 56.3785 100.271C56.3785 100.435 56.5069 100.563 56.6703 100.563C57.8607 100.563 58.4208 101.543 58.6776 102.395C58.3041 102.127 57.7906 101.963 57.1254 102.115C56.9737 102.15 56.8687 102.302 56.9037 102.465C56.9387 102.629 57.0904 102.722 57.2538 102.687C58.5375 102.407 58.8993 103.656 58.911 103.714C58.946 103.842 59.0627 103.924 59.1911 103.924Z"
        fill="#D58270"
      />
      <path
        d="M72.1566 102.932C72.6465 102.932 73.0436 102.384 73.0436 101.707C73.0436 101.03 72.6465 100.481 72.1566 100.481C71.6668 100.481 71.2696 101.03 71.2696 101.707C71.2696 102.384 71.6668 102.932 72.1566 102.932Z"
        fill="#202124"
      />
      <path
        d="M74.2225 101.473C73.3822 100.038 70.9547 100.05 70.1028 101.473C71.5383 100.808 72.7987 100.785 74.2225 101.473Z"
        fill="#202124"
      />
      <path
        d="M81.3773 102.932C81.8671 102.932 82.2642 102.384 82.2642 101.707C82.2642 101.03 81.8671 100.481 81.3773 100.481C80.8874 100.481 80.4903 101.03 80.4903 101.707C80.4903 102.384 80.8874 102.932 81.3773 102.932Z"
        fill="#202124"
      />
      <path
        d="M83.4429 101.473C82.6027 100.038 80.1752 100.049 79.3232 101.473C80.7587 100.808 82.0191 100.785 83.4429 101.473Z"
        fill="#202124"
      />
      <path
        d="M66.9751 104.752C67.1362 104.752 67.2668 104.622 67.2668 104.461C67.2668 104.3 67.1362 104.169 66.9751 104.169C66.8139 104.169 66.6833 104.3 66.6833 104.461C66.6833 104.622 66.8139 104.752 66.9751 104.752Z"
        fill="#D58270"
      />
      <path
        d="M68.1533 105.651C68.2564 105.651 68.34 105.567 68.34 105.464C68.34 105.361 68.2564 105.278 68.1533 105.278C68.0502 105.278 67.9666 105.361 67.9666 105.464C67.9666 105.567 68.0502 105.651 68.1533 105.651Z"
        fill="#D58270"
      />
      <path
        d="M69.1571 104.869C69.2538 104.869 69.3322 104.791 69.3322 104.694C69.3322 104.597 69.2538 104.519 69.1571 104.519C69.0604 104.519 68.9821 104.597 68.9821 104.694C68.9821 104.791 69.0604 104.869 69.1571 104.869Z"
        fill="#D58270"
      />
      <path
        d="M69.636 106.118C69.7649 106.118 69.8694 106.013 69.8694 105.884C69.8694 105.756 69.7649 105.651 69.636 105.651C69.5071 105.651 69.4026 105.756 69.4026 105.884C69.4026 106.013 69.5071 106.118 69.636 106.118Z"
        fill="#D58270"
      />
      <path
        d="M74.8172 103.819C74.9203 103.819 75.0039 103.735 75.0039 103.632C75.0039 103.529 74.9203 103.445 74.8172 103.445C74.714 103.445 74.6304 103.529 74.6304 103.632C74.6304 103.735 74.714 103.819 74.8172 103.819Z"
        fill="#D58270"
      />
      <path
        d="M76.4047 103.212C76.5336 103.212 76.6381 103.107 76.6381 102.979C76.6381 102.85 76.5336 102.745 76.4047 102.745C76.2758 102.745 76.1713 102.85 76.1713 102.979C76.1713 103.107 76.2758 103.212 76.4047 103.212Z"
        fill="#D58270"
      />
      <path
        d="M70.9786 104.694C71.1075 104.694 71.212 104.59 71.212 104.461C71.212 104.332 71.1075 104.227 70.9786 104.227C70.8497 104.227 70.7452 104.332 70.7452 104.461C70.7452 104.59 70.8497 104.694 70.9786 104.694Z"
        fill="#D58270"
      />
      <path
        d="M72.3551 105.266C72.4518 105.266 72.5302 105.188 72.5302 105.091C72.5302 104.994 72.4518 104.916 72.3551 104.916C72.2584 104.916 72.1801 104.994 72.1801 105.091C72.1801 105.188 72.2584 105.266 72.3551 105.266Z"
        fill="#D58270"
      />
      <path
        d="M71.4212 106.188C71.505 106.188 71.5729 106.12 71.5729 106.036C71.5729 105.952 71.505 105.884 71.4212 105.884C71.3374 105.884 71.2694 105.952 71.2694 106.036C71.2694 106.12 71.3374 106.188 71.4212 106.188Z"
        fill="#D58270"
      />
      <path
        d="M75.915 104.484C75.9988 104.484 76.0667 104.416 76.0667 104.332C76.0667 104.249 75.9988 104.181 75.915 104.181C75.8312 104.181 75.7633 104.249 75.7633 104.332C75.7633 104.416 75.8312 104.484 75.915 104.484Z"
        fill="#D58270"
      />
      <path
        d="M72.88 104.192C72.9638 104.192 73.0317 104.124 73.0317 104.041C73.0317 103.957 72.9638 103.889 72.88 103.889C72.7962 103.889 72.7283 103.957 72.7283 104.041C72.7283 104.124 72.7962 104.192 72.88 104.192Z"
        fill="#D58270"
      />
      <path
        d="M73.9188 105.639C74.0155 105.639 74.0939 105.561 74.0939 105.464C74.0939 105.368 74.0155 105.289 73.9188 105.289C73.8221 105.289 73.7437 105.368 73.7437 105.464C73.7437 105.561 73.8221 105.639 73.9188 105.639Z"
        fill="#D58270"
      />
      <path
        d="M74.071 104.636C74.1548 104.636 74.2227 104.568 74.2227 104.484C74.2227 104.4 74.1548 104.332 74.071 104.332C73.9872 104.332 73.9193 104.4 73.9193 104.484C73.9193 104.568 73.9872 104.636 74.071 104.636Z"
        fill="#D58270"
      />
      <path
        d="M68.5628 106.678C68.6466 106.678 68.7145 106.61 68.7145 106.527C68.7145 106.443 68.6466 106.375 68.5628 106.375C68.479 106.375 68.4111 106.443 68.4111 106.527C68.4111 106.61 68.479 106.678 68.5628 106.678Z"
        fill="#D58270"
      />
      <path
        d="M79.0659 104.286C79.1948 104.286 79.2993 104.181 79.2993 104.052C79.2993 103.923 79.1948 103.819 79.0659 103.819C78.937 103.819 78.8325 103.923 78.8325 104.052C78.8325 104.181 78.937 104.286 79.0659 104.286Z"
        fill="#D58270"
      />
      <path
        d="M83.862 105.383C84.0232 105.383 84.1538 105.252 84.1538 105.091C84.1538 104.93 84.0232 104.799 83.862 104.799C83.7009 104.799 83.5703 104.93 83.5703 105.091C83.5703 105.252 83.7009 105.383 83.862 105.383Z"
        fill="#D58270"
      />
      <path
        d="M75.3315 105.242C75.4153 105.242 75.4832 105.175 75.4832 105.091C75.4832 105.007 75.4153 104.939 75.3315 104.939C75.2477 104.939 75.1798 105.007 75.1798 105.091C75.1798 105.175 75.2477 105.242 75.3315 105.242Z"
        fill="#D58270"
      />
      <path
        d="M79.7193 105.324C79.8031 105.324 79.8711 105.256 79.8711 105.173C79.8711 105.089 79.8031 105.021 79.7193 105.021C79.6355 105.021 79.5676 105.089 79.5676 105.173C79.5676 105.256 79.6355 105.324 79.7193 105.324Z"
        fill="#D58270"
      />
      <path
        d="M82.2639 105.768C82.3928 105.768 82.4973 105.663 82.4973 105.534C82.4973 105.405 82.3928 105.301 82.2639 105.301C82.135 105.301 82.0305 105.405 82.0305 105.534C82.0305 105.663 82.135 105.768 82.2639 105.768Z"
        fill="#D58270"
      />
      <path
        d="M81.0852 104.869C81.1819 104.869 81.2603 104.791 81.2603 104.694C81.2603 104.597 81.1819 104.519 81.0852 104.519C80.9886 104.519 80.9102 104.597 80.9102 104.694C80.9102 104.791 80.9886 104.869 81.0852 104.869Z"
        fill="#D58270"
      />
      <path
        d="M82.7999 104.309C82.8837 104.309 82.9517 104.241 82.9517 104.157C82.9517 104.074 82.8837 104.006 82.7999 104.006C82.7162 104.006 82.6482 104.074 82.6482 104.157C82.6482 104.241 82.7162 104.309 82.7999 104.309Z"
        fill="#D58270"
      />
      <path
        d="M80.8043 106.083C80.8881 106.083 80.956 106.015 80.956 105.931C80.956 105.848 80.8881 105.78 80.8043 105.78C80.7205 105.78 80.6526 105.848 80.6526 105.931C80.6526 106.015 80.7205 106.083 80.8043 106.083Z"
        fill="#D58270"
      />
      <path
        d="M73.0561 87.0953C73.0561 87.0953 73.0911 79.9762 80.5019 81.5051C87.9127 83.0339 84.2832 93.9575 84.2832 93.9575C84.2832 93.9575 82.2758 80.8865 73.0561 87.0953Z"
        fill="#A53007"
      />
      <path
        d="M67.0339 79.7196C67.0339 79.7196 77.5841 74.3512 83.4427 83.0691C83.4427 83.0691 76.8722 78.9493 73.0559 87.0954L67.0456 79.7196H67.0339Z"
        fill="#D34F16"
      />
      <path
        d="M87.0251 101.87C87.0251 101.87 87.0368 101.917 87.0368 101.94C87.0601 101.917 87.1068 101.894 87.1651 101.894L87.6203 101.917L87.0251 101.87Z"
        fill="#601802"
      />
      <path
        d="M87.0479 102.617C87.0479 102.617 87.1179 102.664 87.1646 102.664H87.1762V102.629H87.0479V102.617Z"
        fill="#601802"
      />
      <path
        d="M59.4125 100.528L65.8663 101.847C65.8663 101.847 65.913 101.859 65.9363 101.859H66.0647L66.9867 101.905C66.975 102.057 66.9633 102.209 66.9633 102.372C66.9517 104.881 68.959 106.994 71.4332 107.087C73.9073 107.181 75.9263 105.22 75.9263 102.711C75.9263 102.081 75.8096 101.462 75.5762 100.902C75.973 100.75 76.4398 100.68 76.9533 100.692C77.5485 100.715 78.1087 100.867 78.5522 101.112C78.3421 101.625 78.2254 102.197 78.2254 102.792C78.2254 105.302 80.2328 107.414 82.7069 107.507C85.1811 107.601 87.1884 105.64 87.2001 103.131C87.2001 102.967 87.2001 102.816 87.1767 102.664H87.1651C87.1651 102.664 87.0717 102.652 87.0484 102.617H87.1767V102.664L88.2621 102.711C88.3555 102.711 88.4371 102.629 88.4371 102.536V102.127C88.4488 102.022 88.3671 101.94 88.2621 101.94L87.6202 101.917L87.1651 101.894C87.1651 101.894 87.06 101.917 87.0367 101.94C87.0367 101.917 87.0367 101.894 87.025 101.87C86.4998 99.9565 84.7726 98.4977 82.7186 98.416C81.003 98.3459 79.5092 99.2679 78.7623 100.68C78.2954 100.377 77.6536 100.167 76.9533 100.143C76.3465 100.12 75.7979 100.237 75.3545 100.447C74.5842 99.0345 73.1254 98.0425 71.4565 97.9842C69.3908 97.9025 67.6519 99.2563 67.1267 101.17C67.1034 101.147 67.0684 101.135 67.0334 101.135L65.9363 101.089H65.9013L58.899 99.7114C58.7823 99.9448 59.4825 100.283 59.4125 100.528ZM78.7623 102.816C78.7623 100.598 80.5362 98.8711 82.7186 98.9528C84.4575 99.0228 85.9397 100.225 86.4648 101.824H86.3248L84.6092 101.672C84.6092 101.917 84.6092 102.162 84.5975 102.419L86.3014 102.559L86.6282 102.582C86.6516 102.757 86.6632 102.932 86.6632 103.108C86.6632 105.325 84.8893 107.052 82.7069 106.97C80.5245 106.889 78.7623 105.033 78.7623 102.816ZM67.4885 102.384C67.5002 100.178 69.2741 98.451 71.4565 98.5327C73.6389 98.6144 75.4011 100.47 75.4011 102.687C75.3895 104.905 73.6156 106.632 71.4332 106.55C69.2508 106.469 67.4885 104.601 67.4885 102.384Z"
        fill="#601802"
      />
      <path
        d="M87.0479 102.617C87.0479 102.617 87.1179 102.664 87.1646 102.664H87.1762V102.629H87.0479V102.617Z"
        fill="#601802"
      />
      <path
        d="M127.253 179.841H179.981C180.354 179.841 180.681 179.619 180.809 179.269L195.164 141.888C195.386 141.305 194.954 140.675 194.336 140.675H141.608C141.235 140.675 140.908 140.896 140.779 141.247L126.425 178.627C126.203 179.211 126.635 179.841 127.253 179.841Z"
        fill="#A4C9EB"
      />
      <path
        d="M99.2091 184.638H179.047C180.014 184.638 180.798 183.854 180.798 182.887V180.565C180.798 179.598 180.014 178.814 179.047 178.814H99.2091C98.2422 178.814 97.4585 179.598 97.4585 180.565V182.887C97.4585 183.854 98.2422 184.638 99.2091 184.638Z"
        fill="#6FAAE3"
      />
      <path
        d="M163.573 162.903C165.417 161.379 166.069 159.125 165.03 157.868C163.991 156.611 161.655 156.827 159.811 158.35C157.968 159.874 157.316 162.128 158.355 163.385C159.394 164.642 161.73 164.426 163.573 162.903Z"
        fill="#EDEFF1"
      />
      <path
        d="M12.2868 198.164L405.666 198.164C406.955 198.164 408 197.119 408 195.83V186.937C408 185.648 406.955 184.603 405.666 184.603L12.2868 184.603C10.9977 184.603 9.9527 185.648 9.9527 186.937V195.83C9.9527 197.119 10.9977 198.164 12.2868 198.164Z"
        fill="#EDEFF1"
      />
      <path
        d="M201.081 177.834L201.664 184.112C201.687 184.393 201.956 184.603 202.271 184.603H211.082C211.397 184.603 211.654 184.393 211.689 184.112L212.273 177.834H201.104H201.081Z"
        fill="#A6CBED"
      />
      <path
        d="M212.787 164.973H200.556C200.206 164.973 199.926 165.241 199.949 165.556L200.521 171.742H212.81L213.382 165.556C213.405 165.241 213.137 164.973 212.775 164.973H212.787Z"
        fill="#A6CBED"
      />
      <path d="M200.521 171.753L201.081 177.834H212.25L212.81 171.753H200.521Z" fill="#EFF1F3" />
      <path
        d="M212.459 161.577H200.87C200.393 161.577 200.007 161.963 200.007 162.44V163.106C200.007 163.583 200.393 163.969 200.87 163.969H212.459C212.936 163.969 213.323 163.583 213.323 163.106V162.44C213.323 161.963 212.936 161.577 212.459 161.577Z"
        fill="#6EACE5"
      />
      <path d="M200.054 163.584L213.323 162.767V163.958L200.054 164.541V163.584Z" fill="#228BE6" />
      <path
        d="M213.65 163.584H199.692C199.215 163.584 198.828 163.971 198.828 164.448V165.113C198.828 165.59 199.215 165.977 199.692 165.977H213.65C214.127 165.977 214.514 165.59 214.514 165.113V164.448C214.514 163.971 214.127 163.584 213.65 163.584Z"
        fill="#6EACE5"
      />
      <path
        d="M206.508 174.73L206.589 174.695C206.951 174.543 207.208 174.228 207.313 173.866C207.313 173.843 207.313 173.819 207.29 173.808C207.266 173.784 207.243 173.761 207.208 173.749C206.788 173.469 206.158 173.679 205.808 174.216C205.527 174.648 205.492 175.15 205.702 175.477C205.726 175.512 205.796 175.512 205.808 175.465C205.924 175.138 206.181 174.87 206.508 174.73Z"
        fill="#228BE6"
      />
      <path
        d="M207.628 174.099C207.628 174.099 207.535 174.064 207.523 174.111C207.406 174.449 207.161 174.718 206.811 174.869L206.729 174.904C206.379 175.056 206.123 175.36 206.018 175.71C206.018 175.733 206.018 175.756 206.029 175.768C206.053 175.791 206.088 175.815 206.111 175.838C206.531 176.118 207.161 175.908 207.511 175.371C207.803 174.939 207.826 174.426 207.616 174.099H207.628Z"
        fill="#228BE6"
      />
      <path
        d="M305.987 107.227C305.532 108.534 304.82 109.666 303.921 110.611L270.66 150.98L255.85 138.761L289.006 98.8473C289.006 98.8473 289.03 98.8006 289.053 98.789C291.399 95.2294 295.95 93.5839 300.163 95.0661C305.135 96.8166 307.737 102.255 305.987 107.227Z"
        fill="#59332F"
      />
      <path
        d="M271.605 149.451C269.329 154.201 263.622 156.196 258.873 153.921C257.974 153.477 257.157 152.929 256.457 152.263C256.27 152.088 256.083 151.902 255.92 151.715C255.92 151.715 255.897 151.703 255.885 151.692L254.473 149.626L237.189 124.312L243.211 118.676L269.726 138.41L269.633 138.504C272.492 141.281 273.402 145.67 271.582 149.462L271.605 149.451Z"
        fill="#59332F"
      />
      <path
        d="M240.854 127.137C242.943 127.3 244.927 125.993 245.522 123.892C246.012 122.142 245.382 120.333 244.051 119.247L243.526 118.874L236.255 113.716C236.057 113.587 235.859 113.506 235.625 113.447L229.008 112.35C228.518 112.198 227.981 112.467 227.829 112.969C227.678 113.47 227.958 113.984 228.459 114.147L234.271 116.703L234.248 116.738L229.23 118.209C229.113 118.174 228.973 118.115 228.856 118.08L218.108 115.116C217.968 115.069 217.804 115.046 217.653 115.058C217.302 115.081 216.976 115.291 216.824 115.641C216.626 116.108 216.824 116.645 217.267 116.89L225.519 124.347C226.009 124.779 226.592 125.094 227.234 125.211C227.374 125.246 227.538 125.246 227.689 125.258V125.281L240.865 127.137H240.854Z"
        fill="#59332F"
      />
      <path
        d="M347.838 198.339H284.817L283.673 182.374L283.487 179.841L283.452 179.398C283.452 179.398 283.44 179.304 283.44 179.258C283.428 179.188 283.428 179.106 283.428 179.036L283.358 177.974C283.358 177.974 283.347 177.881 283.347 177.834C283.335 177.472 283.323 177.11 283.323 176.76C283.288 171.053 284.665 166.525 285.494 164.308C285.844 163.397 286.708 162.814 287.676 162.814H337.463C338.198 162.814 338.91 163.141 339.33 163.747C343.485 169.594 345.072 177.729 345.586 181.288C345.609 181.417 345.609 181.568 345.597 181.697V181.778H345.609L345.761 182.899L345.948 184.299L346.484 188.314L347.033 192.352L347.838 198.339Z"
        fill="#A4C9EB"
      />
      <path
        d="M283.346 177.834L283.311 177.344C283.311 177.145 283.311 176.959 283.323 176.76C283.323 177.11 283.335 177.472 283.346 177.834Z"
        fill="#6EACE5"
      />
      <path
        d="M265.572 139.659C265.572 139.659 263.424 144.339 266.213 147.42C269.003 150.501 268.384 153.291 268.384 153.291C268.384 153.291 270.695 151.808 272.819 148.611C274.943 145.413 276.74 144.981 276.74 144.981L265.56 139.659"
        fill="#B76B5C"
      />
      <path
        d="M275.504 147.49L259.375 135.271C258.289 134.443 258.138 132.867 259.048 131.852L289.975 97.5872C292.134 94.0511 296.405 92.1604 300.642 93.1524C305.532 94.3078 308.706 98.906 308.204 103.773C308.099 104.555 307.924 105.336 307.668 106.107C307.306 107.145 306.781 108.079 306.104 108.896C306.022 109.024 305.917 109.141 305.812 109.258L278.795 147C278.024 148.074 276.531 148.296 275.492 147.502L275.504 147.49Z"
        fill="#6EACE5"
      />
      <path
        d="M285.447 164.599H340.299L354.7 109.246C356.836 102.057 352.961 94.4361 345.959 92.0903C341.081 90.4565 334.009 89.2894 323.773 89.2894C308.847 89.2894 299.954 91.6585 294.679 94.3077C289.906 96.7119 287.128 101.894 287.746 107.274L285.447 164.599Z"
        fill="#A4C9EB"
      />
      <path
        d="M298.798 83.361C297.864 82.404 297.607 80.9802 298.156 79.7548L299.206 77.3857L301.155 72.9975L303.104 77.3857L304.155 79.7548C304.691 80.9802 304.435 82.404 303.513 83.361C302.229 84.6914 300.105 84.6797 298.809 83.361H298.798Z"
        fill="#6EACE5"
      />
      <path
        d="M299.265 81.3069C298.518 80.5367 298.319 79.393 298.751 78.4126L299.591 76.5103L301.155 72.9858L302.719 76.5103L303.559 78.4126C303.991 79.393 303.793 80.5367 303.046 81.3069C302.019 82.369 300.315 82.369 299.276 81.3069H299.265Z"
        fill="#A4C9EB"
      />
      <path
        d="M299.837 78.8211C299.311 78.2843 299.171 77.479 299.475 76.7905L300.07 75.46L301.167 72.9975L302.264 75.46L302.859 76.7905C303.163 77.479 303.023 78.2726 302.497 78.8211C301.774 79.568 300.583 79.568 299.86 78.8211H299.837Z"
        fill="#6EACE5"
      />
      <path
        d="M310.375 69.1345V93.6193C310.375 94.7163 311.04 95.7083 312.055 96.1168C314.308 97.0154 318.696 97.3656 324.496 91.0868C325.173 90.3516 325.558 89.3829 325.558 88.3792V69.1228H310.375V69.1345Z"
        fill="#77463F"
      />
      <path
        d="M310.375 72.5889V90.935C310.375 90.935 320.785 91.7403 323.341 76.0317V72.5889H310.375Z"
        fill="#59332F"
      />
      <path
        d="M327.623 62.2138C327.623 62.4355 327.623 62.6456 327.6 62.8556C327.612 62.8673 327.612 62.879 327.6 62.8906C327.297 65.3531 326.701 66.9637 326.701 66.9637C326.701 66.9637 326.538 67.5589 326.211 68.5275C326.2 68.5625 326.176 68.5975 326.164 68.6326C324.484 73.5342 318.719 87.4805 307.737 86.932C297.922 86.4418 297.56 70.6165 298.062 62.3071V62.2138C298.12 61.4435 298.167 60.7433 298.225 60.1247C298.225 60.0664 298.237 60.0197 298.237 59.9613C298.237 59.938 298.237 59.9147 298.249 59.8913C299.357 52.8423 305.473 47.4388 312.848 47.4388C321.006 47.4388 327.623 54.056 327.623 62.2138Z"
        fill="#77463F"
      />
      <path
        d="M305.613 75.2732H304.924C304.446 75.2732 304.002 75.0398 303.722 74.643C303.454 74.2462 303.383 73.7443 303.559 73.3009L305.321 66.2985C305.356 66.1468 305.531 66.0418 305.671 66.0885C305.823 66.1235 305.928 66.2869 305.881 66.4386L304.107 73.4759C303.99 73.7794 304.025 74.0711 304.2 74.3162C304.375 74.5613 304.632 74.6897 304.924 74.6897H305.613C305.776 74.6897 305.904 74.818 305.904 74.9814C305.904 75.1448 305.776 75.2732 305.613 75.2732Z"
        fill="#59332F"
      />
      <path
        d="M305.555 53.4961C305.555 53.4961 304.773 58.0359 308.017 59.1796C311.261 60.3234 309.417 64.1279 313.269 65.33C317.12 66.5321 318.427 64.0463 320.668 65.33C322.909 66.6138 324.589 64.1279 324.589 64.1279L306.406 52.6208L305.555 53.4961Z"
        fill="#B76B5C"
      />
      <path
        d="M313.794 64.8631C313.794 64.8631 313.677 64.8631 313.619 64.8397L309.313 63.4743C309.009 63.3809 308.834 63.0541 308.927 62.739C309.021 62.4356 309.348 62.2605 309.663 62.3539L313.969 63.7194C314.273 63.8127 314.448 64.1395 314.354 64.4546C314.273 64.6997 314.051 64.8631 313.794 64.8631Z"
        fill="#202124"
      />
      <path
        d="M298.109 64.8629C297.864 64.8629 297.63 64.6996 297.549 64.4545C297.455 64.151 297.619 63.8243 297.934 63.7192L302.24 62.3538C302.555 62.2604 302.87 62.4238 302.975 62.7389C303.069 63.0423 302.905 63.3691 302.59 63.4741L298.284 64.8396C298.225 64.8629 298.167 64.8629 298.109 64.8629Z"
        fill="#202124"
      />
      <path
        d="M300.07 53.951C301.868 53.951 303.326 52.4932 303.326 50.6949C303.326 48.8966 301.868 47.4388 300.07 47.4388C298.271 47.4388 296.814 48.8966 296.814 50.6949C296.814 52.4932 298.271 53.951 300.07 53.951Z"
        fill="#202124"
      />
      <path
        d="M329.012 64.6413C330.353 64.6413 331.44 63.5545 331.44 62.2139C331.44 60.8732 330.353 59.7864 329.012 59.7864C327.672 59.7864 326.585 60.8732 326.585 62.2139C326.585 63.5545 327.672 64.6413 329.012 64.6413Z"
        fill="#202124"
      />
      <path
        d="M299.487 49.3879C300.814 49.3879 301.891 48.3115 301.891 46.9838C301.891 45.656 300.814 44.5796 299.487 44.5796C298.159 44.5796 297.082 45.656 297.082 46.9838C297.082 48.3115 298.159 49.3879 299.487 49.3879Z"
        fill="#202124"
      />
      <path
        d="M326.269 67.5588C327.649 67.5588 328.767 66.4407 328.767 65.0613C328.767 63.682 327.649 62.5638 326.269 62.5638C324.89 62.5638 323.772 63.682 323.772 65.0613C323.772 66.4407 324.89 67.5588 326.269 67.5588Z"
        fill="#202124"
      />
      <path
        d="M326.328 67.5706C326.328 67.5706 330.611 59.7864 326.258 50.2982L326.9 48.1042H301.762V50.2282C301.762 50.2282 298.167 52.1888 298.342 59.1678L304.691 52.9007L326.328 67.5823V67.5706Z"
        fill="#A4C9EB"
      />
      <path
        d="M304.68 52.9007L301.155 50.695C301.155 50.695 298.051 52.1538 298.331 59.1795L304.68 52.9124V52.9007Z"
        fill="#6EACE5"
      />
      <path
        d="M303.163 48.9328C305.36 48.9328 307.142 47.151 307.142 44.9531C307.142 42.7552 305.36 40.9734 303.163 40.9734C300.965 40.9734 299.183 42.7552 299.183 44.9531C299.183 47.151 300.965 48.9328 303.163 48.9328Z"
        fill="#202124"
      />
      <path
        d="M308.449 46.9838C311.143 46.9838 313.327 44.7997 313.327 42.1055C313.327 39.4113 311.143 37.2272 308.449 37.2272C305.755 37.2272 303.571 39.4113 303.571 42.1055C303.571 44.7997 305.755 46.9838 308.449 46.9838Z"
        fill="#202124"
      />
      <path
        d="M326.271 59.3313C328.965 59.3313 331.149 57.1473 331.149 54.4531C331.149 51.7589 328.965 49.5748 326.271 49.5748C323.576 49.5748 321.392 51.7589 321.392 54.4531C321.392 57.1473 323.576 59.3313 326.271 59.3313Z"
        fill="#202124"
      />
      <path
        d="M318.369 50.5668C321.605 50.5668 324.228 47.9438 324.228 44.7082C324.228 41.4726 321.605 38.8496 318.369 38.8496C315.134 38.8496 312.511 41.4726 312.511 44.7082C312.511 47.9438 315.134 50.5668 318.369 50.5668Z"
        fill="#202124"
      />
      <path
        d="M314.109 42.9342C316.307 42.9342 318.089 41.1525 318.089 38.9546C318.089 36.7567 316.307 34.9749 314.109 34.9749C311.912 34.9749 310.13 36.7567 310.13 38.9546C310.13 41.1525 311.912 42.9342 314.109 42.9342Z"
        fill="#202124"
      />
      <path
        d="M326.585 51.1152C329.279 51.1152 331.463 48.9311 331.463 46.2369C331.463 43.5427 329.279 41.3586 326.585 41.3586C323.891 41.3586 321.707 43.5427 321.707 46.2369C321.707 48.9311 323.891 51.1152 326.585 51.1152Z"
        fill="#202124"
      />
      <path
        d="M311.495 51.8039C313.693 51.8039 315.475 50.0222 315.475 47.8243C315.475 45.6264 313.693 43.8446 311.495 43.8446C309.297 43.8446 307.515 45.6264 307.515 47.8243C307.515 50.0222 309.297 51.8039 311.495 51.8039Z"
        fill="#202124"
      />
      <path
        d="M306.722 51.6637C308.92 51.6637 310.701 49.882 310.701 47.6841C310.701 45.4862 308.92 43.7044 306.722 43.7044C304.524 43.7044 302.742 45.4862 302.742 47.6841C302.742 49.882 304.524 51.6637 306.722 51.6637Z"
        fill="#202124"
      />
      <path
        d="M329.491 53.5893C331.689 53.5893 333.47 51.8075 333.47 49.6096C333.47 47.4117 331.689 45.63 329.491 45.63C327.293 45.63 325.511 47.4117 325.511 49.6096C325.511 51.8075 327.293 53.5893 329.491 53.5893Z"
        fill="#202124"
      />
      <path
        d="M302.089 50.9051C303.526 50.9051 304.691 49.7399 304.691 48.3026C304.691 46.8653 303.526 45.7001 302.089 45.7001C300.651 45.7001 299.486 46.8653 299.486 48.3026C299.486 49.7399 300.651 50.9051 302.089 50.9051Z"
        fill="#202124"
      />
      <path
        d="M315.44 52.866C316.639 52.866 317.611 51.8941 317.611 50.6953C317.611 49.4964 316.639 48.5245 315.44 48.5245C314.241 48.5245 313.27 49.4964 313.27 50.6953C313.27 51.8941 314.241 52.866 315.44 52.866Z"
        fill="#202124"
      />
      <path
        d="M320.249 55.9586C321.448 55.9586 322.419 54.9867 322.419 53.7878C322.419 52.589 321.448 51.6171 320.249 51.6171C319.05 51.6171 318.078 52.589 318.078 53.7878C318.078 54.9867 319.05 55.9586 320.249 55.9586Z"
        fill="#202124"
      />
      <path
        d="M331.091 55.8067C332.29 55.8067 333.261 54.8348 333.261 53.636C333.261 52.4371 332.29 51.4652 331.091 51.4652C329.892 51.4652 328.92 52.4371 328.92 53.636C328.92 54.8348 329.892 55.8067 331.091 55.8067Z"
        fill="#202124"
      />
      <path
        d="M319.618 42.9459C321.488 42.9459 323.003 41.4306 323.003 39.5615C323.003 37.6923 321.488 36.177 319.618 36.177C317.749 36.177 316.234 37.6923 316.234 39.5615C316.234 41.4306 317.749 42.9459 319.618 42.9459Z"
        fill="#202124"
      />
      <path
        d="M324.333 44.9065C326.203 44.9065 327.718 43.3912 327.718 41.522C327.718 39.6528 326.203 38.1376 324.333 38.1376C322.464 38.1376 320.949 39.6528 320.949 41.522C320.949 43.3912 322.464 44.9065 324.333 44.9065Z"
        fill="#202124"
      />
      <path
        d="M321.8 52.6206C322.999 52.6206 323.971 51.6488 323.971 50.4499C323.971 49.2511 322.999 48.2792 321.8 48.2792C320.601 48.2792 319.629 49.2511 319.629 50.4499C319.629 51.6488 320.601 52.6206 321.8 52.6206Z"
        fill="#202124"
      />
      <path
        d="M318.182 53.9512C319.381 53.9512 320.353 52.9794 320.353 51.7805C320.353 50.5817 319.381 49.6098 318.182 49.6098C316.984 49.6098 316.012 50.5817 316.012 51.7805C316.012 52.9794 316.984 53.9512 318.182 53.9512Z"
        fill="#202124"
      />
      <path
        d="M326.13 61.2452C328.825 61.2452 331.009 59.0611 331.009 56.3669C331.009 53.6727 328.825 51.4886 326.13 51.4886C323.436 51.4886 321.252 53.6727 321.252 56.3669C321.252 59.0611 323.436 61.2452 326.13 61.2452Z"
        fill="#202124"
      />
      <path
        d="M327.999 69.9038C328.631 67.4909 327.839 65.1931 326.231 64.7717C324.622 64.3503 322.805 65.9648 322.173 68.3777C321.541 70.7907 322.333 73.0884 323.941 73.5098C325.55 73.9313 327.367 72.3168 327.999 69.9038Z"
        fill="#77463F"
      />
      <path
        d="M323.341 69.8464C323.341 69.8464 323.306 69.8464 323.294 69.8464C323.154 69.823 323.037 69.6947 323.049 69.5429C323.096 68.2825 323.761 65.9017 325.862 65.9017C326.025 65.9017 326.153 66.0301 326.153 66.1935C326.153 66.3569 326.025 66.4853 325.862 66.4853C324.671 66.4853 324.111 67.4656 323.854 68.3175C324.228 68.0491 324.741 67.8857 325.407 68.0374C325.558 68.0725 325.663 68.2242 325.628 68.3876C325.593 68.5509 325.442 68.6443 325.278 68.6093C323.994 68.3292 323.633 69.578 323.621 69.6363C323.586 69.7647 323.469 69.8464 323.341 69.8464Z"
        fill="#59332F"
      />
      <path
        d="M311.261 67.6292C311.261 68.3061 310.865 68.8546 310.374 68.8546C309.884 68.8546 309.487 68.3061 309.487 67.6292C309.487 66.9523 309.884 66.4038 310.374 66.4038C310.865 66.4038 311.261 66.9523 311.261 67.6292Z"
        fill="#202124"
      />
      <path
        d="M308.309 67.4074C309.149 65.9719 311.577 65.9836 312.429 67.4074C310.993 66.7422 309.733 66.7188 308.309 67.4074Z"
        fill="#202124"
      />
      <path
        d="M301.155 68.8547C301.645 68.8547 302.042 68.306 302.042 67.6293C302.042 66.9525 301.645 66.4039 301.155 66.4039C300.665 66.4039 300.268 66.9525 300.268 67.6293C300.268 68.306 300.665 68.8547 301.155 68.8547Z"
        fill="#202124"
      />
      <path
        d="M299.09 67.4074C299.93 65.972 302.358 65.9836 303.209 67.4074C301.774 66.7422 300.514 66.7189 299.09 67.4074Z"
        fill="#202124"
      />
      <path
        d="M310.586 75.413C310.586 75.413 310.562 75.5881 310.516 75.8565C310.492 75.9732 310.481 76.0666 310.457 76.1599C310.259 76.9885 309.804 78.284 308.823 78.7275C307.796 79.1826 306.583 78.319 305.929 77.7355C305.637 77.4787 305.451 77.2686 305.451 77.2686L310.586 75.413Z"
        fill="black"
      />
      <path
        d="M307.715 78.7858C307.715 78.7858 308.205 77.5138 309.688 77.9806C309.688 77.9806 308.987 79.136 307.715 78.7858Z"
        fill="#C61B41"
      />
      <path
        d="M310.586 75.413C310.586 75.413 310.562 75.5881 310.516 75.8565C310.492 75.9732 310.481 76.0666 310.457 76.1599L305.929 77.7355C305.637 77.4787 305.451 77.2686 305.451 77.2686L310.586 75.413Z"
        fill="white"
      />
      <path
        d="M329.689 60.9066C331.404 60.9066 332.794 59.5168 332.794 57.8023C332.794 56.0878 331.404 54.6979 329.689 54.6979C327.975 54.6979 326.585 56.0878 326.585 57.8023C326.585 59.5168 327.975 60.9066 329.689 60.9066Z"
        fill="#202124"
      />
      <path
        d="M327.484 63.1826C328.547 63.1826 329.409 62.3205 329.409 61.257C329.409 60.1935 328.547 59.3314 327.484 59.3314C326.42 59.3314 325.558 60.1935 325.558 61.257C325.558 62.3205 326.42 63.1826 327.484 63.1826Z"
        fill="#202124"
      />
      <path
        d="M322.243 83.3608C321.31 82.4038 321.053 80.98 321.601 79.7546L322.652 77.3855L324.601 72.9974L326.55 77.3855L327.6 79.7546C328.137 80.98 327.88 82.4038 326.958 83.3608C325.674 84.6913 323.55 84.6796 322.255 83.3608H322.243Z"
        fill="#6EACE5"
      />
      <path
        d="M322.71 81.3069C321.963 80.5366 321.765 79.3929 322.197 78.4126L323.037 76.5103L324.601 72.9858L326.165 76.5103L327.005 78.4126C327.437 79.3929 327.238 80.5366 326.491 81.3069C325.464 82.3689 323.761 82.3689 322.722 81.3069H322.71Z"
        fill="#A4C9EB"
      />
      <path
        d="M323.282 78.8211C322.757 78.2842 322.617 77.479 322.921 76.7904L323.516 75.46L324.613 72.9975L325.71 75.46L326.305 76.7904C326.608 77.479 326.468 78.2726 325.943 78.8211C325.22 79.568 324.029 79.568 323.306 78.8211H323.282Z"
        fill="#6EACE5"
      />
      <path
        d="M362.169 144.736C362.204 144.153 361.761 143.651 361.189 143.616L359.578 143.511L354.934 143.207L325.839 141.34C325.559 141.317 325.29 141.41 325.08 141.597C324.87 141.784 324.742 142.04 324.73 142.32L321.894 186.645C321.871 186.925 321.964 187.194 322.151 187.404C322.338 187.614 322.594 187.742 322.875 187.754L358.225 190.018C358.505 190.041 358.773 189.948 358.983 189.761C359.193 189.575 359.322 189.318 359.333 189.038L361.726 151.715H361.632C361.702 151.575 361.749 151.435 361.761 151.283L362.181 144.713L362.169 144.736Z"
        fill="#E0E0E0"
      />
      <path
        d="M357.221 160.363L327.519 158.461C327.379 158.461 327.262 158.321 327.274 158.181C327.286 158.041 327.414 157.924 327.554 157.936L357.256 159.838C357.396 159.838 357.512 159.978 357.501 160.118C357.489 160.258 357.361 160.375 357.221 160.363Z"
        fill="#E0E0E0"
      />
      <path
        d="M356.916 163.444L327.215 161.542C327.075 161.542 326.958 161.402 326.97 161.262C326.981 161.122 327.11 161.005 327.25 161.017L356.951 162.919C357.091 162.919 357.208 163.059 357.196 163.199C357.185 163.339 357.056 163.456 356.916 163.444Z"
        fill="#E0E0E0"
      />
      <path
        d="M356.776 166.537L327.074 164.635C326.934 164.635 326.818 164.495 326.829 164.355C326.841 164.215 326.969 164.098 327.109 164.11L356.811 166.012C356.951 166.012 357.068 166.152 357.056 166.292C357.044 166.432 356.916 166.549 356.776 166.537Z"
        fill="#E0E0E0"
      />
      <path
        d="M356.473 169.618L326.771 167.716C326.631 167.716 326.515 167.576 326.526 167.436C326.538 167.296 326.666 167.179 326.806 167.191L356.508 169.093C356.648 169.093 356.765 169.233 356.753 169.373C356.741 169.513 356.613 169.63 356.473 169.618Z"
        fill="#E0E0E0"
      />
      <path
        d="M356.379 172.711L326.678 170.809C326.538 170.809 326.421 170.668 326.433 170.528C326.444 170.388 326.573 170.272 326.713 170.283L356.414 172.186C356.554 172.186 356.671 172.326 356.659 172.466C356.648 172.606 356.519 172.723 356.379 172.711Z"
        fill="#E0E0E0"
      />
      <path
        d="M356.076 175.792L326.375 173.889C326.235 173.889 326.118 173.749 326.13 173.609C326.141 173.469 326.27 173.353 326.41 173.364L356.111 175.267C356.251 175.267 356.368 175.407 356.356 175.547C356.345 175.687 356.216 175.803 356.076 175.792Z"
        fill="#E0E0E0"
      />
      <path
        d="M355.901 178.873L326.199 176.971C326.059 176.971 325.942 176.831 325.954 176.691C325.966 176.55 326.094 176.434 326.234 176.445L355.936 178.348C356.076 178.348 356.192 178.488 356.181 178.628C356.169 178.768 356.041 178.885 355.901 178.873Z"
        fill="#E0E0E0"
      />
      <path
        d="M355.586 181.954L325.885 180.052C325.745 180.052 325.628 179.911 325.64 179.771C325.651 179.631 325.78 179.515 325.92 179.526L355.621 181.429C355.761 181.429 355.878 181.569 355.866 181.709C355.855 181.849 355.726 181.965 355.586 181.954Z"
        fill="#E0E0E0"
      />
      <path
        d="M328.043 150.737L327.908 152.845C327.871 153.423 328.31 153.923 328.889 153.96L336.518 154.449C337.096 154.486 337.596 154.047 337.633 153.468L337.768 151.36C337.805 150.781 337.366 150.282 336.787 150.245L329.159 149.756C328.58 149.718 328.08 150.158 328.043 150.737Z"
        fill="#E0E0E0"
      />
      <path
        d="M305.659 161.309C305.344 160.83 305.484 160.177 305.963 159.862L307.305 158.986L311.179 156.465L335.419 140.687C335.652 140.535 335.933 140.488 336.201 140.535C336.469 140.593 336.715 140.757 336.866 140.99L360.908 177.916C361.059 178.149 361.106 178.429 361.059 178.698C361.001 178.966 360.838 179.211 360.604 179.363L331.159 198.538C330.926 198.689 330.646 198.736 330.377 198.689C330.109 198.631 329.864 198.468 329.712 198.234L309.475 167.144L309.557 167.086C309.429 167.004 309.324 166.899 309.242 166.771L305.683 161.297L305.659 161.309Z"
        fill="#EDEFF1"
      />
      <path
        d="M344.639 170.085L345.981 169.21C346.424 168.918 347.019 169.046 347.311 169.49L352.295 177.157L349.342 179.083L344.359 171.415C344.067 170.972 344.195 170.377 344.639 170.085Z"
        fill="#A4C9EB"
      />
      <path
        d="M337.578 171.532L338.92 170.657C339.364 170.365 339.959 170.493 340.251 170.937L346.681 180.81L343.729 182.736L337.298 172.863C337.006 172.419 337.135 171.824 337.578 171.532Z"
        fill="#6EACE5"
      />
      <path
        d="M330.424 172.828L331.766 171.952C332.21 171.661 332.805 171.789 333.097 172.232L341.068 184.475L338.115 186.401L330.144 174.158C329.852 173.715 329.981 173.119 330.424 172.828Z"
        fill="#228BE6"
      />
      <path
        d="M323.364 174.275L324.706 173.4C325.149 173.108 325.745 173.236 326.036 173.68L335.454 188.139L332.502 190.065L323.084 175.605C322.792 175.162 322.92 174.567 323.364 174.275Z"
        fill="#A4C9EB"
      />
      <path
        d="M314.809 162.896L323.259 157.387C323.375 157.317 323.399 157.166 323.329 157.049C323.259 156.932 323.107 156.909 322.99 156.979L314.541 162.487C314.424 162.557 314.401 162.709 314.471 162.826C314.541 162.942 314.692 162.966 314.809 162.896Z"
        fill="#E0E0E0"
      />
      <path
        d="M316.758 165.883L325.208 160.375C325.324 160.305 325.348 160.153 325.278 160.036C325.208 159.92 325.056 159.896 324.939 159.966L316.49 165.475C316.373 165.545 316.35 165.697 316.42 165.813C316.49 165.93 316.642 165.953 316.758 165.883Z"
        fill="#E0E0E0"
      />
      <path
        d="M318.696 168.883L327.145 163.374C327.262 163.304 327.285 163.152 327.215 163.036C327.145 162.919 326.993 162.896 326.877 162.966L318.427 168.474C318.311 168.544 318.287 168.696 318.357 168.813C318.427 168.929 318.579 168.953 318.696 168.883Z"
        fill="#E0E0E0"
      />
      <path
        d="M331.124 191.232L353.917 176.399C354.033 176.329 354.057 176.177 353.987 176.06C353.917 175.944 353.765 175.92 353.648 175.99L330.856 190.823C330.739 190.894 330.716 191.045 330.786 191.162C330.856 191.279 331.007 191.302 331.124 191.232Z"
        fill="#E0E0E0"
      />
      <path
        d="M333.144 159.897L340.449 155.147C340.566 155.077 340.59 154.925 340.519 154.808L336.365 148.424C336.295 148.308 336.143 148.284 336.026 148.354C335.91 148.424 335.886 148.576 335.956 148.693L339.983 154.878L332.887 159.5C332.77 159.57 332.747 159.721 332.817 159.838C332.887 159.955 333.039 159.978 333.155 159.908L333.144 159.897Z"
        fill="#E0E0E0"
      />
      <path
        d="M340.449 155.147C340.449 155.147 340.542 155.053 340.554 154.995C340.577 154.866 340.496 154.738 340.367 154.715L334.999 153.629C334.882 153.606 334.765 153.664 334.73 153.781L333.879 155.975L330.564 155.041C330.436 155.006 330.307 155.076 330.272 155.205C330.237 155.333 330.307 155.462 330.436 155.497L333.96 156.489C334.077 156.524 334.205 156.465 334.252 156.349L335.116 154.143L340.286 155.182C340.356 155.193 340.414 155.182 340.461 155.147H340.449Z"
        fill="#6EACE5"
      />
      <path
        d="M330.751 156.477C330.856 156.407 330.891 156.279 330.833 156.162L330.355 155.251L331.265 154.773C331.393 154.703 331.428 154.563 331.37 154.446C331.312 154.33 331.16 154.283 331.043 154.341L329.923 154.936C329.806 154.995 329.759 155.146 329.818 155.263L330.413 156.384C330.471 156.5 330.623 156.547 330.74 156.489H330.763L330.751 156.477Z"
        fill="#6EACE5"
      />
      <path
        d="M361.76 157.877L353.987 189.295L345.935 188.244L343.11 155.263H343.192C342.795 151.505 344.639 147.712 348.175 145.787C352.867 143.231 358.737 144.958 361.293 149.65C362.728 152.299 362.81 155.298 361.76 157.877Z"
        fill="#77463F"
      />
      <path
        d="M362.332 152.859L343.204 155.707L335.899 105.383C334.872 101.52 336.354 97.2606 339.89 94.9498C344.29 92.0672 350.207 93.2926 353.089 97.7041C353.895 98.9178 354.361 100.248 354.536 101.602L354.583 101.964L362.321 152.859H362.332Z"
        fill="#77463F"
      />
      <path
        d="M341.138 173.212L335.268 105.22C334.031 101.263 335.42 96.8053 338.968 94.2728C343.064 91.3552 348.608 91.997 351.945 95.5916C352.459 96.1868 352.937 96.8286 353.346 97.5289C353.894 98.4859 354.244 99.5012 354.42 100.54C354.466 100.68 354.478 100.843 354.501 100.995L366.289 170.797C366.639 172.197 365.635 173.574 364.199 173.679L343.636 175.231C342.399 175.325 341.302 174.438 341.15 173.201L341.138 173.212Z"
        fill="#6EACE5"
      />
      <path
        d="M354.198 184.708L354.128 188.723V188.746L354.082 191.033H354.105L354.058 192.597L353.895 198.339H342.014L345.06 192.282L345.772 190.87H345.807L345.866 187.474V187.439L345.924 184.545C345.924 184.463 345.936 184.381 345.936 184.311C346.087 183.132 347.091 182.234 348.305 182.257L351.911 182.327C353.195 182.35 354.222 183.412 354.198 184.708Z"
        fill="#77463F"
      />
      <path
        d="M239.885 128.222C239.885 128.222 247.704 128.316 249.711 132.552C251.719 136.789 249.268 137.909 252.606 140.36C255.943 142.811 252.606 146.86 252.606 146.86L239.885 128.222Z"
        fill="#B76B5C"
      />
      <path
        d="M237.446 114.58C237.446 114.58 235.999 115.618 237.446 117.066C238.893 118.513 240.539 117.439 241.227 118.886C241.916 120.333 244.04 119.26 244.04 119.26C244.04 119.26 238.076 115.035 237.446 114.58Z"
        fill="#B76B5C"
      />
      <path
        d="M218.481 117.999C218.481 117.999 219.835 117.45 221.247 119.073C222.659 120.695 223.301 120.917 224.492 121.663C225.682 122.41 224.772 123.682 224.772 123.682L218.47 117.999"
        fill="#B76B5C"
      />
      <path
        d="M314.379 85.3565C314.379 85.3565 312.103 80.0814 316.339 78.856C320.576 77.6306 321.568 75.4015 321.976 74.853C322.385 74.3045 323.528 74.853 323.528 74.853C323.528 74.853 319.712 83.0924 314.39 85.3565H314.379Z"
        fill="#B76B5C"
      />
      <path
        d="M297.899 67.8741C297.899 67.8741 300.07 69.8465 300.817 72.2739C301.669 75.0048 299.23 74.3163 300.817 76.5687C302.404 78.8211 300.502 81.7621 300.502 81.7621C300.502 81.7621 297.596 75.6351 297.888 67.8741"
        fill="#B76B5C"
      />
      <path
        d="M327.951 66.6019C327.951 66.6019 326.772 67.2438 327.029 68.4459C327.286 69.6479 326.294 69.4962 326.434 70.2781C326.574 71.0601 327.309 71.5502 327.309 71.5502C327.309 71.5502 328.873 68.831 327.951 66.6019Z"
        fill="#B76B5C"
      />
      <path
        d="M314.821 96.6187C314.821 96.6187 315.487 93.6894 317.809 93.386C320.131 93.0825 320.727 93.561 321.684 92.429C322.641 91.297 323.749 91.8922 323.749 91.8922C323.749 91.8922 321.263 94.6231 318.287 95.8368C316.327 96.6304 314.821 96.6304 314.821 96.6304V96.6187Z"
        fill="#B76B5C"
      />
      <path
        d="M357.466 175.243C357.466 175.243 352.005 178.056 352.798 180.577C353.592 183.097 351.024 184.626 351.923 186.202C352.822 187.777 354.374 187.766 354.374 187.766"
        fill="#B76B5C"
      />
      <path
        d="M173.713 103.282C195.054 103.282 212.355 85.9821 212.355 64.6412C212.355 43.3002 195.054 26 173.713 26C152.372 26 135.072 43.3002 135.072 64.6412C135.072 85.9821 152.372 103.282 173.713 103.282Z"
        fill="#EDEFF1"
      />
      <path
        d="M189.13 40.6815H158.297C157.923 40.6815 157.62 40.9846 157.62 41.3584V61.7235C157.62 62.0974 157.923 62.4004 158.297 62.4004H189.13C189.504 62.4004 189.807 62.0974 189.807 61.7235V41.3584C189.807 40.9846 189.504 40.6815 189.13 40.6815Z"
        fill="#A6CBED"
      />
      <path
        d="M167.038 51.8266H165.089C164.638 51.8266 164.272 52.1924 164.272 52.6435V57.6269C164.272 58.078 164.638 58.4438 165.089 58.4438H167.038C167.489 58.4438 167.855 58.078 167.855 57.6269V52.6435C167.855 52.1924 167.489 51.8266 167.038 51.8266Z"
        fill="#EDEFF1"
      />
      <path
        d="M172.045 48.2439H170.096C169.645 48.2439 169.279 48.6097 169.279 49.0609V57.627C169.279 58.0782 169.645 58.444 170.096 58.444H172.045C172.496 58.444 172.862 58.0782 172.862 57.627V49.0609C172.862 48.6097 172.496 48.2439 172.045 48.2439Z"
        fill="#228BE6"
      />
      <path
        d="M177.052 44.6376H175.103C174.652 44.6376 174.286 45.0034 174.286 45.4546V57.6386C174.286 58.0898 174.652 58.4556 175.103 58.4556H177.052C177.503 58.4556 177.869 58.0898 177.869 57.6386V45.4546C177.869 45.0034 177.503 44.6376 177.052 44.6376Z"
        fill="#EDEFF1"
      />
      <path
        d="M182.35 50.5079H180.401C179.95 50.5079 179.584 50.8737 179.584 51.3249V57.627C179.584 58.0782 179.95 58.4439 180.401 58.4439H182.35C182.801 58.4439 183.167 58.0782 183.167 57.627V51.3249C183.167 50.8737 182.801 50.5079 182.35 50.5079Z"
        fill="#228BE6"
      />
      <path
        d="M189.13 65.7497H158.297C157.923 65.7497 157.62 66.0528 157.62 66.4266V86.7917C157.62 87.1656 157.923 87.4686 158.297 87.4686H189.13C189.504 87.4686 189.807 87.1656 189.807 86.7917V66.4266C189.807 66.0528 189.504 65.7497 189.13 65.7497Z"
        fill="#A6CBED"
      />
      <path
        d="M175.371 79.6726L171.006 74.8177C170.808 74.5959 170.458 74.5843 170.248 74.7827L165.008 79.766L164.401 79.1241L170.306 73.5106C170.528 73.3005 170.866 73.3122 171.065 73.5456L175.441 78.4239C175.639 78.6456 175.978 78.6573 176.188 78.4589L182.292 72.9504L182.887 73.6039L176.118 79.7076C175.896 79.906 175.558 79.8827 175.371 79.6726Z"
        fill="#6EACE5"
      />
      <path
        d="M170.679 75.1678C171.453 75.1678 172.08 74.5408 172.08 73.7673C172.08 72.9939 171.453 72.3669 170.679 72.3669C169.906 72.3669 169.279 72.9939 169.279 73.7673C169.279 74.5408 169.906 75.1678 170.679 75.1678Z"
        fill="#228BE6"
      />
      <path
        d="M164.844 80.8398C165.617 80.8398 166.244 80.2128 166.244 79.4393C166.244 78.6659 165.617 78.0388 164.844 78.0388C164.07 78.0388 163.443 78.6659 163.443 79.4393C163.443 80.2128 164.07 80.8398 164.844 80.8398Z"
        fill="#228BE6"
      />
      <path
        d="M182.595 75.1678C183.368 75.1678 183.995 74.5408 183.995 73.7673C183.995 72.9939 183.368 72.3669 182.595 72.3669C181.821 72.3669 181.194 72.9939 181.194 73.7673C181.194 74.5408 181.821 75.1678 182.595 75.1678Z"
        fill="#228BE6"
      />
      <path
        d="M176.082 80.8398C176.856 80.8398 177.483 80.2128 177.483 79.4393C177.483 78.6659 176.856 78.0388 176.082 78.0388C175.309 78.0388 174.682 78.6659 174.682 79.4393C174.682 80.2128 175.309 80.8398 176.082 80.8398Z"
        fill="#228BE6"
      />
    </svg>
  );

export default EmptyStateDashboardSinglePage;
